/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} von {b}',
  about: 'Über Uns',
  aboutThisItem: 'Über dieses Element',
  accessApiKeyManager: 'Greifen Sie auf den API-Schlüssel-Manager für diesen Mandanten zu.',
  accessControls: 'Zugriffskontrollen',
  accessControlsCopiedText: 'Zugriffskontrollen werden sofort aktualisiert. Die Sicherheitsberechtigungen für Medien werden in den nächsten Minuten aktualisiert.',
  accessControlsCopiedTitle: 'Zugangskontrollen wurden erfolgreich kopiert',
  accessControlsCopyConfirmation: 'Damit werden alle bestehenden Zugangskontrollen von {to} entfernt und durch Zugangskontrollen von {from} ersetzt. Der Vorgang kann nicht rückgängig gemacht werden.',
  accessControlsDescription: 'Zugangskontrollen definieren, wer die Medien entsprechend der gewählten Organisationen und Medienkategorien ansehen kann.',
  accessControlsHelpText: 'Verwalten Sie die Zugriffskontrollen für diese Organisation. Die Benutzer können nur auf die aufgelisteten Medien zugreifen, wenn sie über die Berechtigung zum Anzeigen der jeweiligen Medienkategorien verfügen. Das Anwenden mehrerer Medien auf eine Organisation kann einige Zeit in Anspruch nehmen. Warten Sie bitte, bis die Änderungen wirksam werden und betätigen Sie dann die Schaltfläche „Aktualisieren“.',
  accessControlsIndeterminance: 'Hinweis: Mutterorganisationen haben immer Zugriff auf Inhalte, die einem ihrer Tochterunternehmen zugewiesen wurden.',
  accessControlsRefreshWarning: 'Sie haben noch nicht gespeicherte Änderungen. Durch das Aktualisieren werden diese verworfen. Möchten Sie fortfahren?',
  accessControlsSaveSuccess: 'Die Zugriffskontrollen wurden erfolgreich gespeichert.',
  accessControlsTitleSection: 'Wenn Zugriffskontrollen auf diese Organisation angewendet werden, werden sie durch Reverse Inheritance auch automatisch an die folgenden Organisationen delegiert:',
  accessControlsTooltip: 'Die Organisationen haben auch Zugriff auf Inhalte, auf die ihre untergeordneten Organisationen Zugriff haben. Die folgende Tabelle enthält keine Inhalte, auf die diese Organisation durch implizite Aufwärtsdelegation oder Reverse Inheritance Zugriff hat.',
  account: 'Konto',
  accountErrorMessage: 'Kontofehlermeldung',
  accountErrorMessageWarning: 'Das Feld accountErrorMessage (Kontofehlermeldung) in der Datenbank wird für den Mandanten auf „Nicht autorisiert“ gesetzt.',
  action: 'Aktion | Aktionen',
  actionDelete: 'löschen',
  actionLoad: 'laden',
  actionPaste: 'Einfügen',
  actionRun: 'ausführen',
  actionSave: 'Speichern',
  actionUndoWarning: 'Der Vorgang kann nicht rückgängig gemacht werden.',
  actionUpload: 'hochladen',
  actualSize: 'Tatsächliche Größe',
  add: 'Hinzufügen',
  addABookText: 'Ein Buch hinzufügen',
  addABookToStart: '{addABookText}, um zu beginnen.',
  addAForm: 'Fügen Sie ein Formular hinzu, um zu beginnen.',
  addAFormOnly: 'Formular hinzufügen',
  addAMedia: 'Medium hinzufügen',
  addAPIKey: 'Einen API-Schlüssel hinzufügen',
  addAPartCollection: 'Fügen Sie eine {partCollection} hinzu, um zu beginnen.',
  addAPrintSettingText: 'Druckeinstellung hinzufügen',
  addAPrintSettingToStart: '{addAPrintSettingText}, um zu beginnen.',
  addASharedCart: 'Gemeinsamen Warenkorb hinzufügen',
  addATag: 'Tag hinzufügen',
  addATemplate: 'Vorlage hinzufügen',
  addAllPartsCart: 'Alle Teile in den Warenkorb legen',
  addAnOrderQuoteEmailFormat: 'E-Mail-Format für Bestellungen/Angebote hinzufügen',
  addBooks: 'Bücher hinzufügen',
  addBrowseFlow: 'Durchsuchungsverlauf hinzufügen',
  addChapter: 'Kapitel hinzufügen',
  addChildBrowseFlow: 'Untergeordneten Durchsuchungsverlauf hinzufügen',
  addComment: 'Kommentar hinzufügen',
  addExistingPart: 'Bestehendes Teil hinzufügen',
  addGroupsToUsers: '{groups}-Gruppen zu {users}-Benutzern hinzufügen',
  addItem: '{item} hinzufügen',
  addMedia: 'Medien hinzufügen',
  addPages: 'Seiten hinzufügen',
  addPart: 'Ein Teil hinzufügen',
  addReports: 'Berichte hinzufügen',
  addRootBrowseFlow: 'Durchsuchungsverlauf für Stammverzeichnis hinzufügen',
  addRow: 'Zeile hinzufügen',
  addTemplates: 'Vorlagen hinzufügen',
  addToCartMessage: '{partNumber} erfolgreich hinzugefügt',
  addToUserGroup: 'Zu Gruppen hinzufügen',
  addWidgetKey: 'Widget-Schlüssel hinzufügen',
  addedOn: 'Hinzugefügt am',
  additionalInformation: 'Weitere Informationen',
  additionalNotification: 'Zusätzliche Benachrichtigung',
  additionalPartNumberDescription: 'Als zusätzliches Teilenummernfeld verwenden',
  address: 'Adresse | Adressen',
  addressInUse: 'Aktuell ist eine Adresse als Standardadresse eingestellt und kann nicht gelöscht werden',
  addressInUseSubtitle: 'Um diese Adresse zu löschen, müssen Sie zuerst die Einstellung als Standardadresse löschen.',
  addressLine: 'Adresszeile {number}',
  addressState: {
    confirmationMessage: 'Die folgenden Adressen sind nicht verifiziert.',
    confirmationTitle: 'Sind Sie sicher, dass Sie mit nicht verifizierten Adressen fortfahren möchten?',
    disabledVerification: 'Die Adressverifizierung wird für dieses Feld bei der Bestell-/Angebotsübermittlung deaktiviert.',
    enteredAddress: 'Eingegebene Adresse',
    failedToFetchSuggestions: 'Es konnten keine Adressvorschläge abgerufen werden.',
    failedToLoadDetails: 'Die Adressdetails konnten nicht geladen werden.',
    incomplete: 'Adresse unvollständig',
    missingSubpremise: 'Sub-Premise fehlt',
    noSuggestions: 'Keine Vorschläge gefunden. Bitte ergänzen Sie die Adresse.',
    selectAddress: '(bitte eine Option auswählen)',
    subpremiseMessage: 'Diese Adresse scheint zu einem Wohn- oder Bürogebäude zu gehören. Bitte fügen Sie der Adresse die Wohnungs-, Apartment- oder Suitenummer hinzu.',
    suggested: 'Vorgeschlagene Adressen',
    unverified: 'Nicht verifizierte Adresse',
    unverifiedHelpText: 'Wählen Sie eine andere gespeicherte Adresse, bearbeiten Sie diese Adresse oder fügen Sie eine neue hinzu.',
    unverifiedMessage: 'Wir können diese Adresse für die Zustellung nicht verifizieren.',
    verified: 'Verifizierte Adresse'
  },
  admin: 'Admin',
  adminCenter: 'Admin-Zentrum',
  adminCenterBanner: {
    bodyLabel: 'Banner-Text',
    enableLabel: 'Admin-Banner aktivieren',
    headerGreenOption: 'Grün',
    headerLabel: 'Banner-Kopfzeile',
    headerRedOption: 'Rot',
    headerYellowOption: 'Gelb',
    title: 'Admin-Center-Banner',
    typeLabel: 'Banner-Typ'
  },
  adminCenterMessage: 'Adminstrationszentrum für Inhalt, Benutzer, Bibliothekseinstellungen, Berichterstattung und Exportfunktion',
  adminMessage: 'Funktionen werden hinzugefügt, sobald sie verfügbar sind',
  administration: 'Administration',
  advancedFilters: 'Erweiterte Filter',
  affectedBookMedia: '{count} Buchmedien werden aktualisiert.',
  affectedProductPages: '{count} Produktseiten werden aktualisiert.',
  affectedTemplateMedia: '{count} Buchvorlagen werden aktualisiert.',
  after: 'Nach',
  aggregatedFromChildren: 'Von den Tochterunternehmen zusammengefasst',
  aiAlgorithm: 'KI-Scanner',
  algorithm: 'Algorithmus',
  alignHorizontal: 'Horizontal Ausrichten',
  alignVertical: 'Vertikal Ausrichten',
  all: 'Alle',
  allLibraryPages: 'Alle Bibliotheksseiten',
  allPagesAndBooks: 'Alle Seiten und Bücher',
  allUsersDisabled: 'Alle Benutzer, die zum Mandanten gehören, werden deaktiviert..',
  alphanumeric: 'Alphanumerisch',
  analyticsJSON: 'Analyse JSON',
  andCountMore: 'und {count} weitere ...',
  announcement: 'Ankündigung | Ankündigungen',
  any: 'Beliebig',
  apiAuthHeader: 'API-Autorisierungs-Kopfzeile',
  apiKey: 'API-Schlüssel | API-Schlüssel',
  apiKeyAdmin: 'API Key-Admin',
  apiKeyCopied: 'Wert von API-Autorisierungs-Kopfzeile in Zwischenablage kopiert',
  apiKeyDeleteMsg: 'Wenn dieser API-Schlüssel gelöscht wird, wird er für die Verwendung durch Integrationen deaktiviert',
  apiKeyDeleteTitle: 'Sind Sie sicher, dass Sie diesen API-Schlüssel löschen möchten?',
  apiKeyDeleted: 'API-Schlüssel  Gelöscht',
  apiKeyDeletedError: 'Fehler beim Löschen des API-Schlüssels',
  apiKeyInstructions: 'Der Schlüssel wird generiert, wenn Gespeichert wird',
  apiKeyManager: 'API-Schlüssel-Manager',
  apiKeyNameEmpty: 'Nachname-Feld darf nicht leer sein',
  apiKeyRegenError: 'Fehler beim erneuten Generieren des API-Schlüssels',
  apiKeyRegenMsg: 'Durch das erneute Generieren dieses API-Schlüssels werden ggf. bestehende Integrationen deaktiviert',
  apiKeyRegenTitle: 'Sind Sie sicher, dass Sie diesen API-Schlüssel erneut generieren möchten?',
  apiKeySaved: 'API-Schlüssel Gespeichert',
  apiKeyType: 'API-Schlüssel-Typ',
  appliesTo: 'Gilt für',
  appliesToEmpty: 'Es muss zumindest ein Objekttyp gewählt werden',
  appliesToPopulated: 'Geben Sie das Objekt ein, für das das Tag verwendet werden kann',
  apply: 'Anwenden',
  applyItem: '{item} anwenden',
  applyToChildItems: 'Für Tochterunternehmen anwenden {item}',
  applyToPartOnly: 'Nur auf dieses Teil anwenden',
  april: 'April',
  areYouSure: 'Sind Sie sicher, dass Sie {item} wirklich löschen möchten?',
  areYouSureCopy: 'Sind Sie sicher, dass Sie {item} kopieren möchten?',
  areYouSureYouWantToDisableTheTenant: 'Wollen Sie den Mandanten wirklich deaktivieren?',
  area: 'Gebiet',
  assembly: 'Baugruppe | Baugruppen',
  assemblyConfirmationTitle: 'Möchten Sie die Erstellung der Baugruppe beenden?',
  assemblyCreatorHelpText1: 'Mit dieser Funktion können Sie eine gewählte Seite überall dort in Bücher einfügen, wo Sie dieses Teil {partName} finden, und das Teil wird automatisch über einen Hotpoint-Link mit der gewählten Seite verbunden. Sie können wahlweise die Einfügungen auf ausgewählte Bücher beschränken.',
  assemblyCreatorHelpText2: 'Die gewählte Seite wird einmal pro Buch eingefügt, nachdem das Teil {partName} das erste Mal aufgetreten ist.',
  assemblyCreatorSuccessSubtitle: 'Änderungen der Hotpoint-Links und des Inhaltsverzeichnisses des Buches erfolgen sofort. Die Suchresultate ändern sich, nachdem die Indizierung abgeschlossen ist.',
  assemblyCreatorSuccessTitle: 'Auftrag „Baugruppe erstellen“ übermittelt',
  assemblyStepOne: 'Schritt 1: Wählen Sie die Seite aus, die eingefügt werden soll',
  assemblyStepTwo: 'Schritt 2: Wählen Sie die Bücher, in die die Seite eingefügt werden soll',
  asset: 'Asset | Assets',
  assetsNotFound: 'Kein {type} Gefunden',
  assignBrowseFlow: 'Durchsuchungsverlauf zuweisen',
  assignMedia: 'Medien zuweisen',
  assignMediaToItem: 'Diesem/r {item} Medien zuweisen.',
  assignedOrganizations: 'Zugewiesene Organisationen',
  associateProductPage: 'Bestehende Produktseite verknüpfen',
  associateProductPageDescription: 'Verknüpfen Sie Produktseiten mit diesem Medium.',
  associateProductPageTip: 'Tipp: Wenn Sie auf „Neue Produktseite erstellen“ klicken, öffnet sich ein Tab zum Hinzufügen einer neuen Produktseite, falls das Produkt, das Sie verknüpfen möchten, noch nicht existiert. Sie müssen anschließend zu dieser Seite zurückkehren, um die neue Produktseite zu verknüpfen.',
  associateProducts: 'Produkte verknüpfen',
  atLeastFiveError: 'Wählen Sie bitte einen Wert aus, der nicht kleiner als 5 ist.',
  attachRelatedPDFs: 'PDFs von zugehörigen Teile-Seiten anhängen',
  attachment: 'Anhang | Anhänge',
  attachmentEditorDescription: 'Hängen Sie direkt an dieses Objekt Bilder, Videos und Dokumente an. Beachten Sie, dass Sie sie in der Registerkarte „Zugehöriges“ finden.',
  attachmentEditorDescriptionPP: 'Hängen Sie direkt an dieses Objekt Bilder, Videos und Dokumente an.',
  attachmentFileUploadSizeError: 'Dateigröße überschreitet das Limit von 50 MB',
  attachmentView: 'Anhänge anzeigen',
  attributions: 'Zuordnungen',
  august: 'August',
  autoHideEmptyCards: 'Leere Karten automatisch ausblenden',
  autoHotpoint: 'Auto-Hotpoint',
  autoPopulate: 'Automatisch ausfüllen',
  automaticZoom: 'Automatischer Zoom',
  availability: 'Verfügbarkeit',
  back: 'Zurück',
  backCover: 'Rückseite',
  backStitch: 'Rückwärts Anheften',
  backToLibrary: 'Zurück zur Bibliothek',
  backToSearch: 'Zurück zur Suche',
  badCredentials: 'Falsche Anmeldeinformationen',
  badDefaultValueMessage: 'Der Standardwert muss zwischen {min} und {max} Zeichen lang sein.',
  bahasaDescription: 'Indonesische Beschreibung (Bahasa)',
  bahasaName: 'Indonesischer Name (Bahasa)',
  banner: 'Banner',
  banners: 'Banner',
  barColor: 'Balkenfarbe',
  before: 'Vorher',
  beginTypingToFindAnything: 'Beginnen Sie mit der Eingabe, um etwas zu finden',
  beta: 'Beta',
  betaAccessKeys: 'Beta-Zugangscodes',
  betaReleaseVideo: 'Betaversion-Video',
  betaResources: 'Beta-Ressourcen',
  blobFinder: 'BLOB-Sucher',
  body: 'Hauptteil',
  bom: 'BOM',
  bomDefaultSupplier: 'Stückliste Standardlieferant',
  bomExportSuccess: 'Export der Stückliste erfolgreich',
  bomItem: 'BOM-Artikel',
  bomItems: 'BOM-Artikel',
  bomLayout: 'Layout der Materialliste',
  bomListOptions: 'Optionen Stückliste (BOM)',
  bomListSettings: 'Einstellungen Stückliste (BOM)',
  book: 'Buch | Bücher',
  bookInserts: 'Buch-Einfügungen',
  bookLabel: 'Buch | Bücher',
  bookPrintingDisable: 'Buchdrucken deaktivieren',
  booksAndPagesDisplay: 'Bücher- und Seitenanzeige',
  boost: 'Verbesserte Suche',
  boostDescription: 'Geben Sie einen Wert über 1,5 ein, um die Suchrelevanz des Tags für Teilenummern, Medienbezeichnungen und Namen zu verbessern',
  boostRangeInvalid: 'Boost muss zwischen 0,5 und 100,0 liegen',
  border: 'Rahmen',
  both: 'Beide',
  bottom: 'Unten',
  branding: 'Branding',
  browse: 'Durchsuchen',
  browseComputer: 'Computer durchsuchen',
  browseFlow: 'Durchsuchungsverlauf | Durchsuchungsverläufe',
  browseFlowAssigned: 'Durchsuchungsverlauf Zugeordnet',
  browseFlowCopyMessage: 'Geben Sie einen Namen für den neuen untergeordneten Durchsuchungsverlauf ein.',
  browseFlowDeleteMessage: 'Wenn Sie einen Durchsuchungsverlauf löschen, wird nicht nur der Durchsuchungsverlauf, sondern werden alle untergeordneten Durchsuchungsverläufe gelöscht.',
  browseFlowDeleted: 'Browse-Flow gelöscht',
  browseFlowEmptyState: 'Keine Durchsuchungsverläufe definiert. {new}, um zu beginnen.',
  browseFlowHierarchy: 'Durchsuchungsverlauf-Hierarchie',
  browseFlowMediaCategoryProductPageHelpText: 'Löschen Sie das aktuell hinzugefügte Suchkriterium „Typ: Produktseite“, um die Änderungen zu übernehmen.',
  browseFlowMoveToRoot: 'Knoten hier ablegen, um erste untergeordnete Ebene zu erstellen',
  browseFlowNoAssignedOrgs: 'Keine Organisationen zugewiesen',
  browseFlowNoExistingCriteria: 'Es wurden keine Suchkriterien für den Durchsuchungsverlauf ausgewählt. Verwenden Sie die Steuerung oben, um Suchkriterien auszuwählen.',
  browseFlowNoExistingCriteriaBelow: 'Für diesen Browserablauf wurden keine Suchkriterien festgelegt. Verwenden Sie die Steuerelemente unten, um Suchkriterien auszuwählen.',
  browseFlowSaveFailed: 'Durchsuchungsverlauf konnte nicht aktualisiert werden',
  browseFlowSaved: 'Durchsuchungsverlauf gespeichert',
  browseFlowSelectionRequired: 'Die Auswahl des Browserablaufs ist erforderlich.',
  browseFlowSetDefaultSuccess: 'Standard-Durchsuchungsverlauf wurde gewählt',
  browseFlowThumbnailDeleteFailTitle: 'Miniaturansicht konnte Nicht Gelöscht werden',
  browseFlowThumbnailDeleteSuccessTitle: 'Miniaturansicht Erfolgreich Gelöscht',
  browseFlowThumbnailUploadFailTitle: 'Miniaturansicht konnte Nicht Hochgeladen werden',
  browseFlowThumbnailUploadSuccessTitle: 'Miniaturansicht Erfolgreich Hochgeladen',
  browseFlowTooManyOrgs: 'Sie haben zu viele Organisationen, um den aktuellen Editor für den Durchsuchungsverlauf zu verwenden. Bitte kontaktieren Sie den Documoto-Support unter  {email}, um Hilfe bei der Bearbeitung Ihrer Documoto Durchsuchungsverläufe zu erhalten.',
  browserDeprecation: {
    text: 'Entsprechend der auslaufenden Unterstützung von Microsoft für den Internet Explorer (alle Versionen) und die verbundenen Sicherheitsbelange, wird der Benutzerzugang auf diese Site via Internet Explorer (alle Versionen) nach dem 30. September 2021 nicht mehr unterstützt.',
    title: 'Mitteilung zur Browser-Nutzungsdauer'
  },
  browserPartiallySupport: 'Möglicherweise gibt es ästhetische Unterschiede und sonstige Änderungen in diesem Browser.',
  buildHotpointLinks: 'Hotpoint-Links erstellen',
  buildHotpointLinksInfo: 'Dieser Vorgang entfernt zunächst alle bestehenden Hotpoint-Links aus den Seiten des Buches und erstellt danach neue Hotpoint-Links zwischen den Teilen und allen übereinstimmenden Baugruppen-Seiten.',
  buildHotpointLinksTitle: 'Möchten Sie Hotpoint-Links in diesem Buch erstellen?',
  bulkApplyAllOrgs: 'Auf alle Organisationen anwenden',
  bulkApplyAllOrgsModalMsg: 'Möchten Sie den Zugriff auf diesen Inhalt wirklich allen Organisationen zuweisen? Wenn Sie auf „Bestätigen“ klicken, wird der Zugriff sofort allen Organisationen zugewiesen und die Änderungen an den Zugriffskontrollen werden gespeichert.',
  bulkExportConfirm: 'Möchten Sie {n} {unit} exportieren?',
  bulkExportLimit: 'Die Begrenzung beträgt {limit} Bücher pro Exportauftrag',
  bulkImport: 'Bulk-Import',
  bulkIndexingLane: 'Massenindexierungsspur',
  bulkInsert: 'Masseneinfügung durchführen',
  bulkPageInsertJob: 'Masseneinfügung von Seiten',
  bulkRemoveAllOrgs: 'Von allen Organisationen entfernen',
  bulkRemoveAllOrgsModalMsg: 'Möchten Sie den Zugriff auf diesen Inhalt wirklich von allen Organisationen entfernen? Wenn Sie auf „Bestätigen“ klicken, wird der Zugriff sofort von allen Organisationen entfernt und die Änderungen an den Zugriffskontrollen werden gespeichert.',
  business: 'Geschäft',
  button: 'Schaltfläche',
  cameraSettings: 'Kameraeinstellungen',
  cancel: 'Abbrechen',
  cancelAssemblyCreatorSubtitle: 'Ihr „Baugruppe erstellen“ wird nicht durchgeführt.',
  cancelAssemblyCreatorTitle: 'Ihr „Baugruppe erstellen“ verwerfen?',
  canceled: 'Abgebrochen',
  cannotExceed100: 'Kann nicht größer als 100 % sein',
  cannyWidgetLoadFailure: 'Das Feedback-Forum konnte nicht geladen werden.',
  cart: 'Warenkorb | Warenkörbe',
  cartBehaviorDisabled: 'Eingabeaufforderung Menge in Warenkorb Hinzufügen deaktivieren',
  cartBehaviorEnabled: 'Eingabeaufforderung Menge in Warenkorb Hinzufügen aktivieren',
  cartBehaviorLabel: 'Mengenverhalten in Warenkorb hinzufügen',
  cartColumn: 'Warenkorb-Spalte | Warenkorb-Spalten',
  cartColumn1: 'Spalte für Preis des 1. Warenkorbs',
  cartColumn2: 'Spalte für Preis des 2. Warenkorbs',
  cartColumn3: 'Spalte für Preis des 3. Warenkorbs',
  cartColumnPartLocationContent1: 'Die Aktivierung dieser Funktion hat folgende Auswirkungen:',
  cartColumnPartLocationContent2: 'Die Eindeutigkeit der Teile-Reihe im Warenkorb basiert auf ihrer Stelle im Inhalt, falls anwendbar.',
  cartColumnPartLocationContent3: 'Diese Einstellung kann auf Organisationsebene nicht deaktiviert werden und gilt für alle Benutzer.',
  cartColumnPartLocationContent4: 'Diese Einstellung sollte nicht aktiviert werden, wenn eine Warenkorb-senden-Integration erfolgte, ohne vorher Ihren Documoto-Kundensupport zu kontaktieren.',
  cartColumnPartLocationOption: 'Teil-Lagerortdaten für Warenkorb aktivieren',
  cartColumnPartLocationTitle: 'Sind Sie sicher, dass Sie Teil-Lagerortdaten für den Warenkorb aktivieren möchten?',
  cartDisable: 'Warenkorb deaktivieren',
  cartEmailFailed: 'Warenkorb-E-Mail fehlgeschlagen',
  cartEmailSent: 'Warenkorb-E-Mail gesendet',
  cartEnable: 'Warenkorb aktivieren',
  cartErpMessage: 'Erfolgreich an ERP gesendet',
  cartImportError: 'Fehler beim Importieren des Warenkorbs',
  cartLoadedWithItemsRemoved: '{count} Artikel entfernt, da Sie derzeit keine Berechtigung haben, diese zu bestellen',
  cartSaveEnable: 'Warenkorb Speichern aktivieren',
  cartSharedAddEdit: 'Gemeinsame Warenkörbe hinzufügen / bearbeiten',
  cartUpdated: 'Warenkorb Aktualisiert',
  cartUpdatedAndRemovedCount: 'Warenkorb wurde Aktualisiert; {count} nicht bestellbare Teile wurden entfernt',
  category: 'Kategorie | Kategorien',
  categoryCreated: 'Kategorie Erstellt',
  categoryNotFoundError: '403: Die Objektkategorie wurde nicht gefunden',
  categoryUpdated: 'Kategorie Aktualisiert',
  centimeter: 'Zentimeter | Zentimeter',
  changeNotification: 'Änderungsmitteilung',
  changeScope: '{n} {type} wird betroffen sein',
  changeUserOrganization: 'Organisation wechseln',
  chapter: 'Kapitel | Kapitel',
  chapterHeader: 'Kapitelüberschrift',
  chaptersOnly: 'Nur Kapitel',
  charLimitHelpText: 'Zwischen {min} und {max} Zeichen eingeben',
  chineseDescription: 'Chinesische Beschreibung',
  chineseName: 'Chinesischer Name',
  circle: 'Kreis',
  city: 'Stadt',
  className: 'Klassenname',
  classicAdminMessage: 'Hierdurch werden Sie an Flex zurückgeleitet, um die Admin-Module zu nutzen.',
  classicAdmins: 'Klassische Admins',
  classicExporter: 'Klassische Exportfunktion',
  classicExporterMessage: 'Altes Flash-basiertes Inhaltsexportmodul',
  classicOrganizationAdmin: 'Klassische Organisationsverwaltung',
  classicOrganizationAdminMessage: 'Altes Flash-basiertes Benutzerverwaltungsmodul zur Verwaltung von Organisationen und Benutzern',
  classicPublisher: 'Klassische Veröffentlichungsfunktion',
  classicPublisherMessage: 'Altes Flash-basiertes Veröffentlichtungsmodul für Inhaltserstellung und Druckeinstellung',
  classicReporting: 'Klassische Berichterstattung',
  classicReportingMessage: 'Altes Flash-basiertes Berichterstattungsmodul',
  classicTenantAdmin: 'Klassische Mandantenverwaltung',
  classicTenantAdminMessage: 'Altes Flash-basiertes Verwaltungsmodul für mandantenübergreifende Einstellungen',
  clear: 'Löschen',
  clearFilters: 'Filter löschen',
  clearHotpoints: 'Hotpoints löschen',
  clearItemNumber: 'Artikelnummer löschen',
  clearItemNumberMessage: 'Durch Löschen der Artikelnummer werden folgende Daten gelöscht:',
  clearItemNumberTitle: 'Artikelnummer löschen?',
  clearSearch: 'Suche löschen',
  clickAction: 'Aktion anklicken',
  clickHereToUpload: 'Datei ablegen oder klicken, um Überschreibungsdatei hochzuladen.',
  clickMagnifyingGlass: 'Klicken Sie auf die Lupe, um direkt zur erweiterten Suche zu gelangen.',
  clickOkToContinue: 'Klicken Sie auf „OK“, um fortzufahren.',
  clickToDownload: 'Klicken für Download',
  clickToEnlarge: 'Klicken um zu vergrößern',
  clickToOpen: 'Zum Öffnen klicken',
  clipboard: 'Zwischenablage',
  clipboardAccessError: 'Passen Sie bitte Ihre Browsereinstellungen an, um den Zugriff auf die Zwischenablage zuzulassen.',
  close: 'Schließen',
  closed: 'Geschlossen',
  collapseAll: 'Alle zuklappen',
  color: 'Farbe | Farben',
  column: 'Spalte | Spalten',
  columnItemType: {
    customText: 'Benutzerdefinierter Text',
    documentTitle: 'Dokumenttitel',
    horizontalLine: 'Horizontale Linie',
    pageName: 'Seitenname',
    pageNumber: 'Seitennummer',
    printDate: 'Druckdatum',
    tenantName: 'Mandantenname',
    userName: 'Benutzername'
  },
  columnMapping: 'Spaltenzuordnung',
  columnName: 'Spaltenname',
  combinedPage: 'Kombinierte Seite',
  combinedPageMessage: 'Diagramm oben, Teileliste unten',
  comingSoon: 'In Kürze verfügbar',
  commaDelimited: 'durch Kommas getrennt',
  comment: 'Kommentar | Kommentare',
  commentAdded: 'Kommentar hinzugefügt',
  commentCannotBeEmpty: 'Kommentar darf nicht leer sein',
  commentDeleted: 'Kommentar gelöscht',
  commentEdit: 'Kommentare hinzufügen / bearbeiten',
  commentEditAll: 'Alle Kommentare bearbeiten',
  commentUpdated: 'Kommentar aktualisiert',
  commentView: 'Kommentare anzeigen',
  commerceSystem: 'Handelssystem',
  completed: 'Beendet',
  configuration: 'Konfiguration | Konfigurationen',
  confirm: 'Bestätigen',
  confirmBrowseFlowApplyToChildren: 'Möchten Sie den Durchsuchungsverlauf für Tochterunternehmen verwenden?',
  confirmBrowseFlowOverrideToChildren: 'Damit werden alle Überschreibungsdateien für die Durchsuchungsverläufe in den Tochterunternehmen gelöscht.',
  confirmPrintSettingsApplyToChildren: 'Möchten Sie diese Druckeinstellung für das Tochterunternehmen verwenden?',
  confirmPrintSettingsOverrideToChildren: 'Damit werden alle Überschreibungsdateien für die Druckeinstellung in den Tochterunternehmen gelöscht.',
  contains: 'Enthält',
  containsHeaderRow: 'Enthält eine Kopfzeile',
  content: 'Inhalt | Inhalte',
  contentAccessControls: '{content} Zugriffskontrollen',
  contentEntity: 'Content-Einheit | Content-Einheiten',
  contentNotFound: 'Inhalt nicht gefunden',
  contentUpdatedQueueJob: 'Warteschlange für Aktualisierte Inhalte',
  contentViewerMoreInfo: 'Mehr Informationen',
  contourShape: 'Umrissform',
  convertEntity: '{entity} konvertieren',
  convertToEntity: 'Konvertieren zu {entity}',
  copiedPartNumber: 'Kopierte Teilenummer {partNumber}',
  copy: 'Kopieren',
  copyAccessControls: 'Zugriffskontrollen kopieren',
  copyAccessControlsWarning: 'Damit werden alle zugewiesenen Zugangskontrollen einer gewählten Organisation in die aktuelle Organisation kopiert',
  copyAndRetain: 'Für Integrationszwecke Kopieren und Aufbewahren',
  copyAndRetainWidget: 'Kopieren & aufbewahren; dies ist das einzige Mal, dass der Widget-Autorisierungswert für Sie in der App sichtbar ist',
  copyAtoB: 'Von {a} nach {b} kopieren',
  copyBranches: 'Branches kopieren',
  copyBranchesMessage: 'Kopieren Sie ausgewählte Branches aus dem Quell-Browserablauf in einen Ziel-Ablauf.',
  copyContent: '{type} kopieren? {name}',
  copyItem: '{item} kopieren',
  copyItemQuestion: '{item} kopieren?',
  copyMeMessage: 'Eine Kopie der Nachricht an mich senden',
  copyPartNumberToClipboard: '{label} in die Zwischenablage kopieren',
  copyProduct: 'Produkt kopieren',
  copyTo: 'Nach {target} kopieren',
  copyingItem: '{item} wird kopiert',
  copyrightMessage: '© 2010-{year} Documoto Inc. Alle Rechte vorbehalten.',
  count: 'Anzahl',
  country: 'Land | Länder',
  coverAmpStitchPages: 'Umschlag und Angeheftete Seiten',
  coverPages: 'Umschlagseiten',
  createAssembly: 'Baugruppe erstellen',
  createNewProductPage: 'Neue Produktseite erstellen',
  created: 'Erstellt',
  createdBy: 'Erstellt von {name}',
  createdDate: 'Erstelltes Datum',
  createdOn: 'Erstellt am',
  currentPassword: 'Aktuelles Passwort',
  custom: 'Benutzerdefiniert',
  czechDescription: 'Tschechische Beschreibung',
  czechName: 'Tschechischer Name',
  dashboard: 'Dashboard | Dashboards',
  dashboardLibrary: 'Dashboard-Bibliothek',
  dataInsights: 'Dateneinblicke',
  dataInsightsInfoMessage: 'Berichterstattung und Dashboard Center für Inhalte, Nutzer- und Bibliotheksdateneinblicke.',
  dataMapping: 'Datenzuordnung/Beispieldaten (bis zu 10 Zeilen)',
  dataOptions: 'Datenoptionen',
  date: 'Datum',
  dateModified: 'Geändert am',
  debugPageBuilderPLZ: 'Debug Seiten-Builder PLZ',
  december: 'Dezember',
  decreaseHotpoint: 'Hotpoint Verringern',
  'default': 'Standardeinstellung',
  defaultAddress: 'Standardadresse',
  defaultBrowseFlow: 'Standard-Durchsuchungsverlauf',
  defaultCurrencyCode: 'Standard-Währungscode',
  defaultCurrencySymbolOn: 'Standardwährungssymbol aktiviert',
  defaultEmailRecipient: 'Standard-E-Mail-Empfänger |Standard-E-Mail-Empfänger',
  defaultImage: 'Standardbild | Standardbilder',
  defaultImagesManager: 'Standardbild-Manager',
  defaultItemImage: '{item} Standardbild',
  defaultPartsListLayout: 'Standardlayout für Teileliste',
  defaultPartsListLayoutHelp: 'Standardlayout für Teileliste links oder unter der Abbildung',
  defaultSearchMode: 'Standard-Suchmodus',
  defaultSearchModeHelp: 'Globale Suchmethode automatisch einstellen auf \'enthält\' oder \'genau\'',
  defaultSortMode: 'Standard-Sortiermodus',
  defaultSupplier: 'Standard-Lieferant',
  defaultTocStateOpen: 'Inhaltsverzeichnis Automatisch im Status Offen',
  defaultTocStateOpenHelp: 'Legt fest, ob das Inhaltsverzeichnis automatisch geöffnet werden soll, wenn ein Buch angesehen wird',
  defaultUom: 'Standard-Maßeinheit',
  defaultValue: 'Standardwert',
  defaultView: 'Standardansicht',
  defaults: 'Standardeinstellungen',
  defaultsAndCapabilities: 'Standardeinstellungen und Möglichkeiten',
  'delete': 'Löschen',
  deleteAll: 'Von Mutterunternehmen übernehmen',
  deleteAnyPartnerApiKeys: 'Löschen Sie alle Partner-API-Schlüssel, die SmartEquip bereitgestellt wurden.',
  deleteContent: 'Sind Sie sicher, dass Sie {item} wirklich löschen möchten? {name}',
  deleteFilesMessage: '{count} Datei(en) wirklich löschen?',
  deleteHotpointLinksTitle: 'Hotpoint-Link(s) wirklich löschen?',
  deleteMessage: 'Wirklich löschen?',
  deletePart: {
    affectedCarts: 'Das Teil wird aus allen Einkaufswagen, die dieses Teil enthalten, entfernt.',
    deletingPartNumber: '{partNumber} wird gelöscht.',
    infoOne: 'Das Löschen eines Teil erfolgt umgehend in der Bibliothek und im Inhalt-Admin. Das gelöschte Teil kann weiterhin gesucht werden, bis die Neuindizierung innerhalb weniger Minuten erfolgte.',
    infoTwo: 'Diese Aktion kann ohne Hilfe des Documoto-Supports nicht rückgängig gemacht werden. Nach 90 Tagen werden der gelöschte Datensatz und alle Verknüpfungen dauerhaft gelöscht.'
  },
  deletePartCollectionConfirmMsg: 'Sind Sie sicher, dass Sie diese {partCollection} von der {productPage} entfernen möchten?',
  deletePartInUse: {
    body: 'Documoto unterstützt derzeit nur das Löschen von Teilen, die nicht zu Seiten gehören. Bitte entfernen Sie diesen Teil von allen veröffentlichten Seiten oder Entwürfen, um mit dem Löschen fortzufahren.',
    submitLabel: 'Zur Seite gehen, auf der es verwendet wird',
    title: 'Dieser Teil gehört zu (einer) Seite(n) und kann nicht gelöscht werden.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} wird gelöscht.',
    infoOne: 'Das Löschen einer Produktseite erfolgt umgehend in der Bibliothek und im Inhalt-Admin. Die gelöschte Produktseite kann weiterhin gesucht werden, bis die Neuindizierung innerhalb weniger Minuten erfolgte.',
    infoTwo: 'Diese Aktion kann ohne Hilfe des Documoto-Supports nicht rückgängig gemacht werden. Nach 90 Tagen werden der gelöschte Datensatz und alle Verknüpfungen dauerhaft gelöscht.'
  },
  deleteRelated: 'Wollen Sie {count} {type} wirklich löschen?',
  deleteSelectedCriteria: 'Gewählte Kriterien löschen',
  deleteTagsTitle: 'Tag(s) wirklich löschen?',
  deleteTaxonMessage: 'Damit wird dieses Taxon mit allen Unterkategorien endgültig gelöscht. Wirklich fortsetzen?',
  deleteTaxonomyMessage: 'Damit werden alle Taxa für diese Organisation oder den Mandanten endgültig gelöscht. Wirklich fortsetzen?',
  deleteTenantSupplier: 'Wollen Sie diesen Lieferanten für den Mandanten wirklich löschen?',
  deletedItem: '{item} gelöscht',
  demo: 'Demo',
  description: 'Beschreibung',
  deselectAll: 'Alle deaktivieren',
  deselectCriteria: 'Kriterien abwählen',
  detail: 'Detail | Details',
  diagonal: 'Diagonal',
  diameter: 'Durchmesser',
  disable: 'Deaktivieren',
  disableAll: 'Alle deaktivieren',
  disableDocumotoTenant: 'Documoto Mandant deaktivieren',
  disableFwdReindex: 'Weiterleitung der Neuindexierung von Zielmedien für DSW deaktivieren',
  disableLibraryBannerImage: 'Bibliotheksbanner-Bild deaktivieren',
  disableSmartEquipModalTitle: 'Wollen Sie diese Lizenz wirklich deaktivieren?',
  disableTEK: 'Direkte URL-Anmeldung deaktivieren',
  disableUserLogin: 'Anmeldung mit Benutzername/Passwort deaktivieren',
  disableUserLoginErrorMessage: 'Ihre Organisation erfordert eine SSO-Authentifizierung. Eine Anmeldung mit Benutzername/Passwort ist für Ihre Benutzergruppe nicht zulässig. Bitte melden Sie sich über SSO an.',
  disableUserLoginTooltip: 'Die Aktivierung erfordert eine funktionierende SSO-Konfiguration. Wenn SSO nicht eingerichtet ist, verlieren die betroffenen Benutzer den Zugriff auf Documoto.',
  disabled: 'Deaktiviert',
  discard: 'Verwerfen',
  discardChanges: 'Änderungen verwerfen',
  discardQ: 'Änderungen verwerfen?',
  discountPrice: 'Reduzierter Preis',
  discounted: 'Reduziert',
  discountedPrice: 'Reduzierter Preis',
  discountedTotal: 'Reduzierung Gesamt',
  displayInOrdersList: 'In der Bestellliste anzeigen',
  displayLocation: 'Anzeigeort',
  displayOrder: 'Reihenfolge',
  displayOrderDescription: 'Stellt die Reihenfolge des Dropdown-Menüs „Filter“ für die Inhaltstyp-Tags ein',
  displaySupplierPartInfo: 'Lieferanteninformationen anzeigen',
  document: 'Dokument | Dokumente',
  documentLabel: 'Dokument | Dokumente',
  documentSettings: 'Dokumenteinstellungen',
  documotoAcademy: 'Documoto Akademie',
  documotoLicensePackage: 'Documoto-Lizenzpaket',
  domain: 'Domain',
  domainEmptyMessage: 'Erlaubte Domain darf nicht leer sein',
  domainInvalidMessage: 'Ein gültiger Domain-Name ist erforderlich',
  download: 'Herunterladen',
  downloadBrowser: 'Laden Sie einen dieser großartigen Browser herunter.',
  downloadFailed: 'Fehler beim Herunterladen von {name}',
  downloadStarted: 'Download von {name} läuft',
  draft: 'Entwurf | Entwürfe',
  draftBomDeleteTitle: 'Diesen Teil wirklich von der Seite löschen?',
  draftBomDropError: 'Teile können nicht tiefer als 5 Ebenen integriert werden',
  draftBomEmptyField: 'Alle Felder in der Teileliste müssen ausgefüllt sein',
  draftBomError: 'Fehler bei der Handhabung von Stücklisten-Entwurf',
  draftBomMultipleDeleteTitle: 'Diese Teile wirklich von der Seite löschen?',
  draftBomQuantityError: 'Anzahl muss eine Zahl sein',
  draftPage: 'Entwurfsseite',
  draftPageDelete: 'Entwurf löschen',
  draftPageDeleteMessage: 'Entwurfsseite erfolgreich gelöscht.',
  draftPageDeleteWarning: 'Durch Löschen des Seitenentwurfs werden alle Fortschritte gelöscht.',
  draftPageLastUpdated: 'Entwurf - zuletzt aktualisiert am {date} durch {username}',
  draftPageLoadError: 'Entwurfsseite konnte nicht geladen werden.',
  draftPageProcessingPlz: 'Seite wird von der PLZ-Datei geladen',
  draftPagePublishInProgress: 'Seiten-Veröffentlichung in Bearbeitung',
  draftPageSaveSuccess: 'Entwurfsseite erfolgreich gespeichert.',
  draftPageSaveUnsuccessful: 'Entwurfsseite nicht erfolgreich gespeichert.',
  draftSheetImageHotpointsFailure: '{algorithm} Hotpoints für das Entwurfsbild können nicht generiert werden.',
  draftValidationMessage: {
    empty: 'Fehler/Warnhinweise Keine Validierung',
    hotpointOrHotpointLink: 'Für die Stücklistenposition {item} wurde(n) kein(e) Hotpoint(s)/Hotpoint-Link(s) angegeben',
    item: 'ACHTUNG: Für BOM Teilenummer {partNumber} wurde keine Artikelnummer angegeben',
    quantity: 'Für die Stücklistenposition {item} wurde keine Menge angegeben',
    supersede: 'Teil {partNumber} hat {supersededPartNumber} aufgrund von Ersetzung ersetzt.',
    tag: 'Der Tag {tagName} der Stücklistenposition {item} hat keinen Tag-Wert',
    translationDescription: 'Die Stücklistenposition {item} hat keine {lang} Übersetzung der Beschreibung',
    uom: 'Für die Stücklistenposition {item} wurde keine Maßeinheit angegeben'
  },
  drawAutohotpointRegion: '{shape}-Größe zeichnen',
  drawMinimumArea: 'Mindestbereich zeichnen',
  dropFileMessage: 'Datei hier ablegen oder zum Hochladen klicken.',
  duplicate: 'Duplikat',
  duplicateSaveError: 'Doppelter Eintrag. Kann nicht gespeichert werden.',
  dutchDescription: 'Niederländische Beschreibung',
  dutchName: 'Niederländischer Name',
  dynamic: 'Dynamisch',
  dynamicNaming: 'Dynamische Namensvergabe',
  ecommerce: 'E-Commerce',
  ecommerceEmailFormatCreated: 'E-Mail-Format für E-Commerce erstellt',
  ecommerceEmailFormatSaved: 'E-Mail-Format für E-Commerce gespeichert',
  ecommerceLogo: 'E-Commerce-Logo',
  ecommerceUseExtOrder: 'Externe Bestellnummer für E-Commerce-Verwendung',
  edit: 'Bearbeiten',
  editItem: '{item} bearbeiten',
  email: 'E-Mail',
  emailAsCsv: 'Als CSV per E-Mail senden (für den Import erforderliches Format)',
  emailAsXlsx: 'Als XLSX per E-Mail senden',
  emailBasicPartInfo: 'Grundlegende Teile-Informationen per E-Mail senden',
  emailComments: 'E-Mail-Kommentare',
  emailDetails: 'E-Mail-Details',
  emailDisplayedCartColumns: 'Angezeigte Warenkorb-Spalten per E-Mail senden',
  emailFormat: 'E-Mail-Format',
  emailFormatTemplate: 'E-Mail-Format-Vorlage | E-Mail-Format-Vorlagen',
  emailList: 'E-Mail-Liste',
  emailMessage: 'Es wird eine E-Mail benötigt',
  emailRecipient: 'E-Mail-Empfänger | E-Mail-Empfänger',
  emailRecipientMessage: 'Eine E-Mail wird an diese E-Mail-Adressen gesendet, wenn der Bestellstatus geändert wird zu ',
  emailSubject: 'E-Mail-Betreff',
  emptyBomState: 'Keine BOM-Artikel für Seite definiert. Klicken Sie auf +{add}, um damit zu beginnen',
  emptyMessage: {
    orderSuggestions: 'Für dieses Teil scheint es noch keine Bestellvorschläge zu geben.'
  },
  enable: 'Aktivieren',
  enable3d: '3D aktivieren',
  enable3dIllustrations: '3D-Illustrationen aktivieren',
  enable3dThumbnails: '3D-Miniaturansichten aktivieren',
  enableAPIKeyAdmin: 'API Key-Admin aktivieren',
  enableAll: 'Alle aktivieren',
  enableCommerce: 'Handel aktivieren',
  enableEcommerceOrderManagement: 'Bestellmanagement aktivieren',
  enableExportToLinkOne: 'Export nach LinkOne aktivieren',
  enableExportToSmartEquip: 'Export nach SmartEquip aktivieren',
  enableExporter: 'Exportfunktion aktivieren',
  enableIframeSupport: 'iFrame-Unterstützung aktivieren',
  enableKnowledgeBase: 'KI-gestützte Suche aktivieren',
  enableLibraryBetaFeatures: 'Beta-Funktionen der Bibliothek aktivieren',
  enableMediaCategorySearch: 'Aktivieren der Gruppierung nach Medienkategorien in der kontextbezogenen Suche',
  enablePDFDownloadWarning: 'Warnung beim Herunterladen großer PDF-Dateien aktivieren',
  enablePLZToDraft: 'PLZ-Verarbeitung zu Entwurf aktivieren',
  enablePerformanceLogging: 'Leistungsprotokollierung aktivieren',
  enableQuickAddToCart: 'Schnelles Hinzufügen zum Warenkorb aktivieren',
  enableQuickAddToCartHelpContext: 'Durch die Einstellung , Aktivieren‘ wird die Funktion „Schnell zum Warenkorb hinzufügen“ über dem Inhaltsbetrachter für diesen Inhalt aktiviert.',
  enableRocketUi: 'Rocket-Benutzererfahrung aktivieren',
  enableSmartEquipApiIntegration: 'SmartEquip API-Integration aktivieren',
  enableWidgetLogo: 'Documoto Widget-Logo aktivieren',
  enableWidgets: 'Widgets aktivieren',
  enabled: 'Aktiviert',
  encryptedKey: 'Verschlüsselungsschlüssel',
  endDate: 'Enddatum',
  endDateBad: 'Das Startdatum muss gleich oder vor dem Enddatum liegen.',
  enforceNumericSize: 'Numerische Größe erzwingen',
  englishDescription: 'Englische Beschreibung',
  englishName: 'Englischer Name',
  enterReportParameters: 'Berichtparameter eingeben',
  enterUniqueNameForNewItem: 'Geben Sie einen Namen für den neuen {item} ein',
  enterValidEmail: 'Bitte geben Sie eine gültige E-Mail ein',
  enterValidNumber: 'Bitte geben Sie eine gültige Nummer ein',
  enterprise: 'Unternehmen',
  entityType: 'Objekttyp | Objekttypen',
  erp: 'ERP',
  erpEndpointConfig: 'ERP-Endpunktkonfiguration',
  erpPartInfo: 'Dauer des ERP-Teile-Info-Caches in Minuten',
  erpSystem: 'ERP-System',
  erpSystemSaved: 'ERP-System gespeichert',
  erpSystems: 'ERP-Systeme',
  error: 'Fehler',
  errorDeletePageMessage: 'Beim Löschen der Seite ist ein Fehler aufgetreten.',
  errorInputParsing: 'Problem beim Parsen von Eingabedatei.',
  errorPageMessage: 'Es ist ein Fehler aufgetreten.',
  errorPageTitle: 'Irgendwas ist hier schiefgelaufen.',
  errorType: {
    error: 'Fehler',
    warning: 'Warnhinweis'
  },
  essential: 'Merkmal | Merkmale',
  eta: 'ETA',
  etlJob: 'ETL',
  exact: 'Genau',
  excelFile: 'Excel-Datei',
  existing: 'Vorhanden',
  expandAll: 'Alle aufklappen',
  'export': 'Exportieren',
  exportAsCSVDropdown: 'Als CSV exportieren',
  exportAsCsv: 'Als CSV exportieren (für den Import erforderliches Format)',
  exportAsHtml: 'Als HTML exportieren',
  exportAsPdf: 'Als PDF exportieren',
  exportAsPlz: 'Als PLZ exportieren',
  exportAsXlsx: 'Als XLSX exportieren',
  exportBasicPartInfo: 'Grundlegende Teile-Informationen exportieren',
  exportCartToXlsxDisabled: 'Export von Warenkorb nach XLSX deaktivieren',
  exportCartToXlsxEnabled: 'Export von Warenkorb nach XLSX aktivieren',
  exportDisplayedCartColumns: 'Angezeigte Warenkorb-Spalten exportieren',
  exportJob: 'Exportauftrag',
  exportLane: 'Exportspur',
  exportMessage: 'Exportauftrag erfolgreich übermittelt.',
  exportParts: 'Teile Exportieren',
  exportPartsXlsx: 'Teile nach XLSX exportieren',
  exportSearch: 'Suche exportieren',
  exporter: 'Exportfunktion',
  exporterMessage: 'Ermöglicht den Export von Inhalten',
  external: 'Extern| Externe',
  externalUrl: 'Externe URL',
  faceted: 'Facettiert',
  facetedTag: 'Filterwerte sollten mehr Kriterien enthalten',
  facetedTagTooMany: 'Tag überschreitet das 1000-Tagwertlimit',
  failedAction: '{content} konnte nicht {action}',
  failedProcessContentSql: 'Inhalt konnte aufgrund von unzulässigem Text nicht bearbeitet werden. Bitte laden Sie den unterstützten Inhalt erneut hoch.',
  failedToCopy: '{content} konnte nicht kopiert werden.',
  failedToDelete: '{content} konnte nicht gelöscht werden.',
  failedToLoad: '{content} konnte nicht geladen werden.',
  failedToSave: '{content} konnte nicht gespeichert werden.',
  failedToSubmitFeedback: 'Das Feedback konnte nicht übermittelt werden.',
  failedToSubmitItem: '{item} konnte nicht gesendet werden',
  failedToUpdate: '{content} konnte nicht aktualisiert werden.',
  'false': 'Falsch',
  faq: 'FAQ',
  favorites: 'Favoriten',
  favoritesLists: 'Favoriten-Liste',
  february: 'Februar',
  feedbackForm: 'Feedback senden',
  feedbackFormMessage: 'Nennen Sie uns die Funktionen, die Sie gerne hätten',
  field: 'Feld | Felder',
  fieldDefinition: 'Feldbestimmung',
  fieldName: 'Feldname',
  file: 'Datei | Dateien',
  fileUpload: 'Hochladen von Dateien',
  filename: 'Dateiname',
  filesSubmitted: 'Datei(en) zur Bearbeitung übermittelt',
  fill: 'Füllen',
  filter: 'Filter | Filter',
  filterBoundsError: 'Filter muss 3 oder mehr Zeichen enthalten',
  filterBy: 'Filtern Nach',
  filterOrgNameOnly: 'Filter: Org Name Only',
  filterOrgParentNames: 'Filter: Name der Org. und des Mutterunternehmens',
  filterable: 'Filterbar',
  filterableTag: 'Filterbares Tag',
  finnishDescription: 'Finnische Beschreibung',
  finnishName: 'Finnischer Name',
  firstName: 'Vorname',
  firstNameEmpty: 'Vorname-Feld darf nicht leer sein',
  fixedHotpointSize: 'Feste Hotpoint-Größe',
  font: 'Schriftart | Schriftarten',
  footer: 'Fußzeile',
  forSearchTerm: 'für {term}',
  forgotPassword: 'Passwort vergessen',
  forgotPasswordMessage: 'Es wird eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts an den angegebenen Benutzernamen gesendet.',
  forgotPasswordSuccess: 'Wenn der angegebene Benutzername gültig ist, wird eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts an die hinterlegte Adresse gesendet.',
  form: 'Formular | Formulare',
  formCount: 'Anzahl der Formulare',
  formName: 'Name des Formulars',
  formType: 'Art des Formulars',
  format: 'Format',
  formattingOptions: 'Formatierungsoptionen',
  freezeImage: 'Bild einfrieren',
  frenchDescription: 'Französische Beschreibung',
  frenchName: 'Französischer Name',
  fri: 'Fr.',
  from: 'Von',
  fromDate: 'Absendedatum',
  frontCover: 'Titelseite',
  frontStitch: 'Vorne Anheften',
  fullScreen: 'Vollbild',
  gdprFaqs: 'DSGVO FAQ',
  gdprMessage: 'Wenn Sie sich in diesem Abschnitt unserer Website anmelden, akzeptieren Sie, dass wir grundlegende Cookies verwenden. Diese Cookies sind grundlegend, um unsere Dienste durchsuchen zu können. Ohne diese Cookies können wir die von Ihnen angeforderten Dienste nicht bereitstellen. Weitere Informationen finden Sie in unserer {policy}.',
  general: 'Allgemeines',
  generalSearch: 'Allgemeine Suche',
  generalSearchCriteriaAlreadySet: 'Die Suchkriterien für die „Allgemeine Suche“ sind bereits festgelegt.',
  generic: 'Allgemein',
  germanDescription: 'Deutsche Beschreibung',
  germanName: 'Deutscher Name',
  goTo: 'Gehe zu',
  goToHome: 'Zur Startseite',
  goToJobManager: 'Zum Auftragsmanager',
  goToPartCollections: 'Gehe zu {partCollections}',
  goToSearch: 'Zur Suche',
  gotIt: 'Verstanden',
  hashKey: 'Rautetaste',
  header: 'Kopfzeile',
  headerAmpFooter: 'Kopf- und Fußzeile',
  help: 'Hilfe',
  helpCenter: 'Hilfe-Center',
  hideBookInSearchAndRecent: 'Bücher in Suchresultaten und Vor Kurzem Hinzugefügt verbergen',
  hideDuplicatePages: 'Doppelte Seiten verbergen',
  hidePageInSearchAndRecent: 'Seiten in Suchresultaten und Vor Kurzem Hinzugefügt verbergen',
  hidePartInSearchAndRecent: 'Teile in Suchresultaten und Vor Kurzem Hinzugefügt verbergen',
  highlightDescription: 'Markieren Sie Teile in der Teileliste mit diesem Tag',
  history: 'Verlauf',
  home: 'Startseite',
  homePageSettings: 'Einstellungen der Startseite',
  homepageOnly: 'Nur Startseite',
  horizontal: 'Horizontal',
  host: 'Host',
  hotpoint: 'Hotpoint | Hotpoints',
  hotpointCalloutBehavior: 'Hotpoint Callout-Verhalten',
  hotpointLink: 'Hotpoint-Link | Hotpoint-Links',
  hotpointLinksWillBeCreated: 'Hotpoint-Links werden in {count} {content} erstellt',
  hotpointShift: 'Hotpoint (Umschalttaste H)',
  hotpointZoomBehavior: 'Hotpoint Zoom-Verhalten',
  hotpointsGenerated: '{count} Hotpoints auf dem Bild gefunden.',
  hourlyDWSRequestLimit: 'Stündliches DWS-Anfragelimit',
  hourlyRESTRequestLimit: 'Stündliches REST-Anfragelimit',
  htmlUiUserSwitchEnabled: 'Benutzerwechsel für HTML-Benutzeroberfläche aktiviert',
  hungarianDescription: 'Ungarische Beschreibung',
  hungarianName: 'Ungarischer Name',
  icon: 'Symbol',
  id: 'ID',
  identifier: 'Bezeichner',
  identifierRequiredErrorMessage: 'Ein Bezeichner ist erforderlich',
  ignore: 'IGNORIEREN',
  ignoreAccessControls: 'Zugriffskontrollen ignorieren',
  ignoreMatchingTranslations: 'Übersetzungen mit passenden Gebietsschemata beim Import ignorieren',
  illustration: 'Illustration | Illustrationen',
  image: 'Bild | Bilder',
  imageDeleteMessage: 'Dieses Seitenbild wirklich löschen?',
  imageDimensionsExceededMessage: 'Die maximale Bildgröße in Documoto beträgt 65,5 Megapixel (8191 X 8191 Pixel).  Das hochzuladende Bild überschreitet die maximale Größe und kann nicht geladen werden.Klicken Sie auf „Größe anpassen“, um die Größe über Documoto anzupassen, und fügen Sie das Bild ein; oder klicken Sie auf „Abbrechen“, um das Bild zu bearbeiten und manuell einzufügen',
  imageOptimizer: 'Bildoptimierer',
  imageSaveFail: 'Bild konnte Nicht Gespeichert werden',
  imageSaveSuccess: 'Bilder erfolgreich aktualisiert',
  imageSizeExceededMessage: 'Die bei Documoto maximal zulässige Bilddateigröße beträgt {size} Megabyte. Das Bild, das Sie hochladen möchten, hat das Maximum überschritten und kann nicht geladen werden. Ändern Sie bitte die Größe des Bildes, um es zu dieser Seite hinzuzufügen.',
  imageSizeExceededTitle: 'Maximale Bildgröße überschritten',
  imageUploadFailure: 'Bild konnte Nicht Hochgeladen werden',
  'import': 'Importieren',
  importBOM: 'Stückliste Importieren',
  importBOMError: 'Beispieldaten konnten nicht verarbeitet werden, Eingangsquelle erneut prüfen',
  importName: 'Name des Imports',
  importParts: 'Teile Importieren',
  inCart: 'In den Warenkorb',
  inCartDescription: 'Tags im Warenkorb anzeigen',
  inPartsList: 'In Teileliste',
  inPartsListDescription: 'Tags in Teileliste anzeigen',
  inch: 'Zoll | Zoll',
  includeComments: 'Kommentare einbeziehen',
  includeCommentsAuthorAndDate: 'Autor und Datum des Kommentars einbeziehen',
  includeHeaderRow: 'Kopfzeile einschließen',
  includeImages: 'Bilder einbinden',
  includeNewParts: 'Nur „neue“ Teile einschließen (nicht in Documoto)',
  includePagePartDetails: 'Details auf Seitenteil-Ebene einschließen',
  includePagesIndex: 'Seitenverzeichnis einbeziehen',
  includePartDetails: 'Details auf Teilebene einschließen',
  includePartsIndex: 'Teileverzeichnis einbinden',
  includePartsList: 'Teileliste einbinden',
  includeSubChapters: 'Unterkapitel einbeziehen',
  includeWatermark: 'Wasserzeichen einfügen?',
  increaseHotpoint: 'Hotpoint Erhöhen',
  indefinitely: 'Unbegrenzt',
  indexIncludeTimestamp: 'Index Zeitstempel einschließen',
  indexLane: 'Index-Spur',
  indexQueueJob: 'Index-Warteschlange',
  indexed: 'Indexiert',
  indexingConfiguration: 'Indexierungskonfiguration',
  info: 'Info',
  information: 'Informationen',
  inherit: 'Übernehmen',
  inherited: 'Übernommen',
  inheritedParent: 'Von Mutterunternehmen übernommen.',
  inputSource: 'Eingabequelle',
  inputSpecification: 'Eingabespezifizierung',
  inputType: 'Eingangstyp',
  inputTypeListboxWarning: 'Sortierkonfigurationen werden nach dem Speichern angezeigt',
  insertDataField: 'Datenfeld einfügen',
  integration: 'Integration | Integrationen',
  integrationsAddPartToErpCart: '{action} Teil zu ERP-Warenkorb hinzufügen',
  integrationsAddToShoppingCartPricingFromErp: '{action} Zum Warenkorb-Preis von ERP hinzufügen',
  integrationsDisableErp: 'ERP deaktivieren',
  integrationsDoErpForQuotes: 'ERP für Angebote verwenden',
  integrationsEnableErp: 'ERP aktivieren',
  integrationsEnableFetchPartInfoFromErp: 'Teileinfo von ERP einholen aktivieren',
  integrationsEnableScopeErp: '{scope} ERP aktivieren',
  integrationsEnableSendShoppingCartToErp: 'Senden von Warenkorb nach ERP aktivieren',
  integrationsEnableSyncPoAddressWithErp: 'PO-Adressen mit ERP Synchronisieren aktivieren',
  integrationsErpAvailabilityMappedFrom: 'ERP-Verfügbarkeit Erstellt Aus',
  integrationsErpCurrencyCodeMappedFrom: 'ERP-Währungscode Erstellt Aus',
  integrationsErpDiscountedPriceMappedFrom: 'ERP-Reduzierter Preis Erstellt Aus',
  integrationsErpEtaMappedFrom: 'ERP-ETA Erstellt Aus',
  integrationsErpMappings: 'ERP-Mappings',
  integrationsErpRetailPriceMappedFrom: 'ERP-Verkaufspreis Erstellt Aus',
  integrationsErpWholesalePriceMappedFrom: 'ERP-Großhandelspreis Erstellt Aus',
  integrationsInvokeGetPartInfoFromClient: 'GetPartInfo vom Client aufrufen',
  integrationsParseAddressForType: 'Adresse nach Typ aufgliedern',
  integrationsShoppingCartAndPartsTitle: 'Warenkorb und Teile',
  integrationsShoppingCartAvailability: '{action} Warenkorb-Verfügbarkeit',
  integrationsShoppingCartEtaFromErp: '{action} Warenkorb-ETA von ERP',
  internalApiKey: 'Interner API-Schlüssel',
  internalDescription: 'Interne Beschreibung',
  internalName: 'Interner Name',
  internalNameOptional: 'Ihre Bezeichnung für das Tag',
  internalNameRequired: 'Ein Name ist erforderlich',
  invalidDecimals: 'Es sind nur zwei Dezimalstellen zulässig',
  invalidField: '{field} ist ungültig',
  invalidFileType: 'Dateityp wird nicht unterstützt. Bitte gehen Sie zum Documoto Support Center, um eine vollständige Liste der unterstützten Dateierweiterungen anzuzeigen.',
  isSearchable: 'Ist Durchsuchbar',
  isSystem: 'Ist das System',
  italianDescription: 'Italienische Beschreibung',
  italianName: 'Italienischer Name',
  item: 'Nr.',
  itemAlt: 'Element',
  itemCopied: '{item} kopiert',
  itemDeleted: '{item} gelöscht',
  itemDetails: 'Elementdetails',
  itemInProgress: '{item} in Arbeit',
  itemInformation: '{item}-Informationen',
  itemMustBeLteItem: '{itemA} muss gleich oder vor {itemB} sein.',
  itemMustBeUnique: '{item} muss einmalig sein',
  itemMustBeUniqueAndNotEmpty: '{item} muss einmalig sein und ist erforderlich',
  itemName: '{item}-Name',
  itemSaved: '{item} gespeichert',
  itemSpecification: 'Spezifizierung der Position',
  january: 'Januar',
  japaneseDescription: 'Japanische Beschreibung',
  japaneseName: 'Japanischer Name',
  job: 'Auftrag| Aufträge',
  jobManager: 'Auftragsmanager',
  jobManagerMessage: 'Aufträge exportieren, veröffentlichen und drucken/herunterladen',
  july: 'Juli',
  june: 'Juni',
  knowledgeBase: {
    config: {
      fetchUsage: 'Abrufverwendung',
      maxTokensDefault: 'Standardmäßige maximale Anzahl an Tokens pro Monat',
      maxTokensOverride: 'Überschreiben der maximalen Anzahl an Tokens pro Monat',
      noData: 'Es sind keine Konfigurationsdaten verfügbar.'
    },
    errors: {
      maxFileSizeExceeded: 'Die Datei überschreitet die Dateigrößenbeschränkung für die Wissensdatenbank.',
      maxTokensExceeded: 'Sie haben das Token-Limit erreicht.',
      pageNavigationFailed: 'Navigation zur Seite ist fehlgeschlagen.'
    },
    feedback: {
      prompt: 'Danke für den Hinweis. Was war an dieser Antwort falsch?',
      reasons: {
        hardToUnderstand: 'Schwer zu verstehen',
        incorrect: 'Falsch',
        missingInfo: 'Fehlende Informationen',
        offTopic: 'Thema verfehlt'
      },
      submitted: 'Ihr Feedback wurde übermittelt.'
    },
    library: {
      buttonText: 'KI fragen',
      disclaimer: 'Die Documoto-KI kann Fehler machen. Überprüfen Sie die Antworten auf Richtigkeit.',
      inputPlaceholder: 'Eine Frage stellen ...',
      noContent: 'Für dieses Dokument ist kein Kontext verfügbar.',
      promptDefault: 'Fragen werden ausschließlich zu diesem Dokument beantwortet. Bitte stellen Sie jeweils nur eine Frage.',
      reference: 'PDF-Referenz',
      serviceError: 'Fehler beim Generieren des Kontexts.',
      title: 'KI-gestützte Suche'
    },
    tenantKnowledgeBase: 'Mandanten-Wissensdatenbank',
    usage: {
      inputTokens: 'Gesamtzahl der eingegebenen Token',
      noData: 'Es sind keine Nutzungsdaten verfügbar.',
      outputTokens: 'Gesamtzahl der ausgegebenen Token',
      title: 'Zusammenfassung der Token-Nutzung',
      totalTokens: 'Insgesamt verwendete Token'
    }
  },
  koreanDescription: 'Koreanische Beschreibung',
  koreanName: 'Koreanischer Name',
  label: 'Bezeichnung | Bezeichnungen',
  labelKey: 'Beschreibung der Bezeichnungen',
  landscape: 'Querformat',
  laneConfiguration: 'Spurkonfiguration',
  language: 'Sprache',
  largePDFDownloadWarning: 'Aufgrund der Größe der PDF-Datei kann das Laden und Anzeigen des Dokuments in der Anwendung länger als gewöhnlich dauern. Bitte haben Sie Geduld, während die Datei zum Anzeigen heruntergeladen wird.',
  lastGenerated: 'Zuletzt Generiert',
  lastModifiedDate: 'Datum der letzten Änderung',
  lastName: 'Nachname',
  lastNameEmpty: 'Nachname-Feld darf nicht leer sein',
  lastUpdatedOn: 'Zuletzt aktualisiert am',
  layout: 'Layout',
  layoutOptions: 'Layout-Optionen',
  ledger: 'Hauptbuch',
  left: 'Links',
  legal: 'Impressum',
  letter: 'Brief',
  library: 'Bibliothek',
  libraryAdmin: 'Bibliotheksverwaltung',
  libraryBannerLogo: 'Logo Bibliotheksbanner',
  librarySettings: 'Bibliothekseinstellungen',
  librarySettingsDescription: 'Diese Einstellungen steuern verschiedene Elemente und Optionen der Bibliothek. Gehen Sie sorgfältig vor, wenn Sie Änderungen durchführen. Kontaktieren Sie Documoto Services für weitere Informationen.',
  licenseConfiguration: 'Lizenzkonfiguration',
  line: 'Linie',
  lineTool: 'Linienwerkzeug',
  link: 'Link | Links',
  listBox: 'Listenfeld',
  listBoxValue: 'Listenfeld-Wert | Listenfeld-Werte',
  listValue: 'Listenwert | Listenwerte',
  load: 'Laden',
  loadMore: 'Mehr laden',
  loading: 'Wird geladen',
  loadingParts: 'Teile werden geladen',
  locale: 'Standort',
  logiReportName: 'Logi-Report-Name',
  logiReportToggle: 'Logi-Report?',
  login: 'Anmelden',
  loginBackground: 'Anmeldung-Hintergrund',
  loginGDPRMessageBeginning: 'Diese Website verwendet Cookies. Wenn Sie diese Website weiterhin nutzen, stimmen Sie der Verwendung von Cookies zu. Weitere Informationen finden Sie in unserer ',
  loginGDPRMessageEnd: 'und unseren',
  loginSSO: 'SSO-Anmeldung',
  logo: 'Logo | Logos',
  logout: 'Abmelden',
  lookupLoadParts: 'Beim Importieren Teile aus Documoto Suchen/Laden',
  lowerBound: 'Untere Grenze',
  mOfNShown: '{m} von {n} angezeigt',
  mToM: 'M2M',
  mainInfo: 'Hauptinfo',
  mainLogo: 'Hauptlogo',
  makePagesDivisibleBy: 'Seiten Teilbar machen Durch:  ',
  manageItem: '{item} verwalten',
  management: 'Management',
  manuallyResetPassword: 'Passwort manuell zurücksetzen',
  manuallySetPassword: 'Passwort manuell festlegen',
  march: 'März',
  margin: 'Marge | Margen',
  markdown: 'Abschlag',
  maxCharHelpMessage: 'Legen Sie einen beliebigen Wert zwischen {min} und {max} Zeichen für das maximale Zeichenlimit fest.',
  maxCharacters: 'Max. Zeichenzahl',
  may: 'Mai',
  media: 'Medium | Medien',
  mediaBookDeleteMessage: 'Wenn Sie diese Mediendatei löschen, wird der Zugang zu diesem Inhalt in der Bibliothek und Inhaltsverwaltung entfernt und er wird nicht mehr für Benutzer oder Inhaltsadministratoren verfügbar sein. Alle in diesem Buch enthaltenen Teile oder Seiten, die in anderen Büchern nicht zu finden sind, werden auch in der Bibliothek nicht mehr verfügbar sein.',
  mediaCategory: 'Medienkategorie | Medienkategorien',
  mediaCategoryEditor: 'Medienkategorie-Editor',
  mediaCategoryName: 'Bezeichnung der Medienkategorie',
  mediaCategoryNameMissing: 'Für alle Medienkategorien ist ein Name erforderlich',
  mediaDeleteMessage: 'Wenn Sie die Vorlage löschen, wird sie gelöscht von der Inhaltsverwaltung und sie wird nicht mehr zum Kopieren in neue Medien verfügbar sein.',
  mediaDeleteSuccessText: 'Sie wird von den Listen gelöscht, nachdem die Indizierung abgeschlossen ist.',
  mediaDescription: 'Medienbeschreibung',
  mediaIdentifier: 'Medienkennung',
  mediaIdentifierDescription: 'Die interne Mediennummer, nach der Endbenutzer suchen können',
  mediaName: 'Medienname',
  mediaPrintSettingsSaveSuccess: 'Medien-Druckeinstellungen gespeichert',
  mediaWhereUsed: 'Medien-Verwendungsnachweis',
  menu: 'Menü',
  merge: 'Zusammenführen',
  mergeOrOverrideMessage: 'Möchten Sie diese Elemente überschreiben oder zusammenführen?',
  mergeWarning: 'Durch das Importieren von Daten werden vorhandene Teile aktualisiert und die neuen Einträge hinzugefügt',
  message: 'Nachricht',
  messageLevel: 'Nachrichtenebene',
  messageMessage: 'Eine Nachricht ist erforderlich',
  metadata: 'Metadaten',
  microsite: 'Microsite | Microsites',
  micrositeAdmin: {
    cardSubtitle: 'Die komprimierte Inhaltsdatei und HTML-Eingabeinformationen',
    cardTitle: 'Site Content',
    errorRequiredFile: 'Es wird eine Site Content ZIP-Datei benötigt',
    fieldFile: 'Site Content ZIP-Datei',
    fieldPoint: 'HMTL-Eingabe-Punkt'
  },
  minArea: 'Mindestbereich',
  minAreaMessage: 'Es muss ein Mindestwert angegeben werden. Der Wert darf den Bereich von 1 bis 1500 nicht überschreiten.  Der Wert muss eine ganze Zahl sein.',
  minCharacters: 'Min. Zeichenzahl',
  minMaxCharHelpMessage: 'Legen Sie einen beliebigen Wert zwischen {min} und {max} Zeichen für die minimalen/maximalen Zeichenlimits fest. Der Maximalwert muss größer oder gleich dem Minimalwert sein.',
  mine: 'Mein',
  miscellaneous: 'Sonstiges',
  mon: 'Mo.',
  month: 'Monat',
  moreInfo: 'Mehr Informationen',
  multipleAlternatingPages: 'Mehrere Alternierende Seiten',
  multipleAlternatingPagesMessage: 'Diagramm auf Seite 1 und 3, Teileliste auf Seite 2 und 4.',
  multiplePages: 'Mehrere Seiten',
  multiplePagesMessage: 'Diagramm auf eigener Seite und Teilelisten-Seiten',
  myCart: 'Mein Warenkorb | Meine Warenkörbe',
  nItemsCreated: '{n} {items} Erstellt',
  nItemsDeleted: '{n }{items} Gelöscht',
  nOfMItems: '{n} von {m} {items}',
  name: 'Name',
  nameDescriptionHelpText: 'Name und wahlweise Beschreibung',
  navigation: 'Navigation',
  'new': 'Neu',
  newAPIKey: 'Neuer API-Schlüssel',
  newERPSystem: 'Neues ERP-System',
  newItem: 'Neues {item}',
  newKeyGenerated: 'Neuer Integrationsschlüssel Generiert, Für eine zukünftige Verwendung Kopieren und Aufbewahren',
  newMediaCategory: 'Neue Medienkategorie',
  newPassword: 'Neues Passwort',
  newTenant: 'Neuer Mandant',
  newWidgetKey: 'Neuer Widget-Schlüssel',
  newWidgetKeyGenerated: 'Neuer Widget-Schlüssel generiert; kopieren und für zukünftige Verwendung aufbewahren',
  newsItem: 'Nachricht | Nachrichten',
  noAPIKeys: 'Keine API-Schlüssel festgelegt.',
  noData: 'Keine Daten',
  noFileSelected: 'Keine Datei ausgewählt',
  noFilesSelected: 'Keine Dateien Ausgewählt',
  noFormsMessage: 'Keine Formulare Festgelegt.',
  noIllustrationFound: 'Keine Illustration Gefunden',
  noImageFound: 'Kein Bild Gefunden',
  noItemAddedToTarget: 'Kein {item} zum {target} hinzugefügt. ',
  noItemAvailable: 'Kein {item} verfügbar',
  noItemFound: 'Kein {item} gefunden.',
  noItemSelected: 'Kein {item} ausgewählt',
  noItemsFound: 'Keine Elemente Gefunden',
  noMediaDefined: 'Keine Medien festgelegt',
  noMoreResults: 'Keine weiteren Ergebnisse',
  noPartCollectionsFound: 'Keine {partCollection} gefunden.',
  noPartsSelected: 'Keine Teile gewählt.',
  noPrice: 'Preisanfrage',
  noResults: 'Keine Ergebnisse',
  noSearchResultsHelpText: 'Keine Ergebnisse gefunden',
  noSearchableCategories: 'Keine durchsuchbaren Kategorien',
  noSearchableTags: 'Keine durchsuchbaren Tags',
  noSuggestions: 'Keine Vorschläge zum Suchbegriff',
  noSupercedingPartsFoundForPartNumber: 'Für diese Teilenummer wurden keine ersetzenden Teile gefunden.',
  noTagsFound: 'Keine Tags gefunden',
  noTenantSuppliers: 'Dem Mandanten wurden keine Lieferanten zugewiesen.',
  noUnsavedChanges: 'Keine Nicht Gespeicherten Änderungen',
  noWidgetKeys: 'Keine Widget-Schlüssel definiert.',
  node: 'Knoten',
  nonSearchableFieldsSuccessfullyUpdated: 'Nicht durchsuchbare Felder erfolgreich aktualisiert.',
  none: 'Keine',
  norwegianDescription: 'Norwegische Beschreibung',
  norwegianName: 'Norwegischer Name',
  notAvailable: 'n. v.',
  notImplemented: 'Nicht Implementiert',
  notMapped: 'Nicht Abgebildet',
  notOrderable: 'Nicht Bestellbar',
  notSelected: 'Nicht ausgewählt',
  notification: 'Benachrichtigung | Benachrichtigungen',
  notificationsMessage: 'Wichtige Ankündigungen und Nachrichten',
  november: 'November',
  numberOf: 'Nr. von {item}',
  numeric: 'Numerisch',
  october: 'Oktober',
  of: 'von',
  off: 'Aus',
  offlineContent: 'Offline-Inhalt',
  ok: 'Okay',
  oldPassword: 'Altes Passwort',
  on: 'Ein',
  opacity: 'Opazität',
  open: 'Öffnen',
  openItem: '{item} öffnen',
  openTab: 'Link in einer neuen Registerkarte öffnen',
  optimizeIndexJob: 'Index Optimieren',
  optionalConfiguration: 'Optionale Konfiguration | Optionale Konfigurationen',
  options: 'Optionen',
  order: 'Bestellung | Bestellungen',
  orderAttachmentHelpText: 'Sie können bis zu 10 Dateien mit jeweils bis zu 50 MB anhängen. Zulässige Dateitypen: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Bestellverlauf deaktivieren',
  orderEmailRecipient: 'Standard-E-Mail-Empfänger |Standard-E-Mail-Empfänger',
  orderEntity: 'Bestelleinheit | Bestelleinheiten',
  orderField: {
    nameMessage: 'Wenn Sie den Namen des Bestell-/Angebotsfelds ändern, müssen Sie alle Bestell-/Angebotsformulare bzw. E-Mail-Formate aktualisieren, die dieses Feld verwenden.'
  },
  orderFieldCopyMessage: 'Geben Sie einen Namen für das neue Bestell-/Angebotsfeld ein.',
  orderFieldUneditableRequired: 'Wenn Sie ein Bestell-/Angebotsfeld auf „Erforderlich“ und nicht auf „Vom Benutzer bearbeitbar“ setzen, kann Ihr Bestell-/Angebotsformular möglicherweise nicht mehr ausgefüllt werden. Überprüfen Sie bitte, ob Ihre Bestell-/Angebotsformulare ausgefüllt werden können.',
  orderFieldsEmptyMessage: 'Keine Bestell-/Angebotsfelder festgelegt.',
  orderFieldsEmptyPrompt: 'Ein Bestell-/Angebotsfeld hinzufügen',
  orderForm: {
    uniqueNameInputHint: 'Geben Sie einen Namen für das neue Formular ein.'
  },
  orderFormField: 'Bestell-/Angebotsformularfeld | Bestell-/Angebotsformularfelder',
  orderFormLayout: 'Bestell-/Angebotsformular-Layout | Bestell-/Angebotsformulare-Layouts',
  orderFormSetDefault: 'Standardauftrags-/Angebotsformular-Satz',
  orderFormType: 'Bestellformular',
  orderLayout: 'Bestellung-Layout | Bestellungen-Layout',
  orderManagementApprover: 'Bestellmanagement-Genehmigungen',
  orderManagementDisable: 'Bestellmanagementverwaltung deaktivieren',
  orderManagementViewer: 'Bestellmanagement-Anzeige',
  orderNumber: 'Bestellnummer',
  orderQuoteDeleteWarning: 'Felder, die auf ein Bestell- oder Angebotsformular angewendet oder in einer E-Mail-Vorlage verwendet werden oder bei zuvor übermittelten Bestellungen oder Angeboten verwendet wurden, können nicht gelöscht werden.',
  orderQuoteEmail: 'E-Mail-Adresse für Bestellungen/Angebote | E-Mail-Adressen für Bestellungen/Angebote',
  orderQuoteEmailFormat: 'E-Mail-Format für Bestellungen/Angebote| E-Mail-Formate für Bestellungen/Angebote',
  orderQuoteEmailFormatCopyMessage: 'Sprache für das neue E-Mail-Format für Bestellungen/Angebote auswählen.',
  orderQuoteFetchError: 'Fehler beim Abrufen der Bestell-/Angebotsformulardaten',
  orderQuoteForm: 'Bestell-/Auftragsformular | Bestell-/Auftragsformulare',
  orderQuoteFormSaved: 'Bestell-/Angebotsformular gespeichert',
  orderQuoteSaveConfirmation: 'Ihre Änderungen an den Bestell-/Angebotsformularen des Unternehmens speichern?',
  orderQuoteSaveError: 'Fehler beim Speichern der Bestell-/Angebotsformulardaten',
  orderStatus: 'Bestell-/Angebotsformular-Status | Bestell-/Angebotsformular-Status',
  orderStatusDeleteMessage: 'Dieser Status wurde für Bestellungen verwendet und kann nicht gelöscht werden.',
  orderSubmittedMessage: 'Erfolgreich Gesendet',
  orderSuggestion: 'Bestellempfehlung | Bestellempfehlungen',
  orderSuggestionEnable: 'Bestellempfehlungen aktivieren',
  orderSuggestionRemovalWarning: 'Das Teil wird nicht mehr als Bestellempfehlung angezeigt. | Die Teile werden nicht mehr als Bestellempfehlungen angezeigt.',
  orderSuggestionThreshold: 'Bestellempfehlung-Grenzwert',
  orderable: 'Bestellbar',
  orderableDescription: 'Teil kann in den Warenkorb hinzugefügt und gekauft werden',
  orderableLocal: 'Kann auf dieser Seite bestellt werden',
  orderableLocalBlocked: 'Teil ist Global nicht Bestellbar',
  ordersLogo: 'Bestellungen-Logo',
  ordersMessage: 'Verlauf der Bestellungen',
  org: 'Org.',
  orgAccessControlsWarning: 'Hinweis: Vorgängerorganisationen (wie Mutter- oder Großmutterunternehmen) erhalten automatisch Zugriff auf Inhalte, die ihren Nachfolgeorganisationen (wie Tochter- oder Enkelunternehmen) zugewiesen sind.',
  orgEmailRecipients: 'E-Mail-Empfänger der Organisation',
  orgNameOnly: 'Nur Name der Org.',
  organization: 'Organisation | Organisationen',
  organizationAdmin: 'Organisationsverwaltung',
  organizationAdminBrowseFlow: 'Eine Organisation kann den Standard-Durchsuchungsverlauf verwenden oder Sie überschreiben ihn und verwenden einen anderen Durchsuchungsverlauf.',
  organizationAdminMessage: 'Steuert Benutzermanagement und Organisationseinstellungen',
  organizationEmailRecipients: 'E-Mail-Emfpänger der Organisation',
  organizationEmpty: 'Organisation muss gewählt werden',
  organizationEnforceAccessControlsForQuickAdd: 'Zugriffssteuerung für Schnelles Hinzufügen aktivieren',
  organizationKey: 'Erklärung der Organisationen',
  organizationLibrarySettingsDescription: 'Diese Einstellungen steuern verschiedene Elemente und Optionen der Bibliothek auf Organisationsebene. Gehen Sie sorgfältig vor, wenn Sie Änderungen durchführen. Kontaktieren Sie Documoto Services für weitere Informationen.',
  organizationMoveToRoot: 'Hier ablegen, um ins Stammverzeichnis zu verschieben',
  organizationName: 'Organisationsname',
  organizationRearrange: 'Organisationen neu ordnen',
  organizationRearrangeDescription: 'Die Mutter-Tochter-Organisationsstruktur definiert viele Attribute einer Organisation, die übernommen werden, wie z. B. Druckeinstellungen, Stile usw. Verschieben Sie die Organisationen, um die gewünschte Hierarchie darzustellen.',
  organizationReportSettingsSuccessMessage: 'Berichterstattungseinstelllungen wurden gespeichert',
  organizationSelect: 'Organisation wählen',
  organizationTags: 'Organisations-Tags',
  organizationsEmpty: 'Sie scheinen noch keine Organisationen erstellt zu haben',
  orientation: 'Orientierung',
  other: 'Sonstige',
  otherSettings: 'Sonstige Einstellungen',
  outboundCustomerIdParameter: 'Parameterbezeichnung für Outbound-Kunden-ID',
  outboundSessionIdParameter: 'Parameterbezeichnung für Outbound Session ID',
  outlineMode: 'Gliederungsmodus (Umschalttaste O)',
  output: 'Ausgabe',
  outputCatalog: 'Ausgabekatalog',
  outputDefinition: 'Ausgabe-Definition | Ausgabe-Definitionen',
  outputDefinitionDeleted: 'Ausgabe-Definition gelöscht',
  outputDefinitionSaved: 'Ausgabe-Definition gespeichert',
  outputDestination: 'Ausgabeziel',
  outputFileName: 'Ausgabe-Dateiname',
  outputName: 'Ausgabe-Name',
  outputSpecification: 'Ausgangsspezifikationen',
  outputSubType: 'Ausgabe-Subtyp',
  outputType: 'Ausgabetyp',
  overridden: 'Überschrieben',
  overriddenByOrg: 'Überschrieben von Organisation',
  override: 'Überschreiben',
  overrideBrowseFlow: 'Durchsuchungsverlauf überschreiben',
  overrideFacetLimitValue: 'Facettengrenzwert überschreiben',
  overrideFontSettings: 'Schriftart-Einstellungen überschreiben',
  overrideHotpointScale: 'Hotpoint-Skala überschreiben',
  overrideOrderForm: 'Bestellformular überschreiben',
  overridePdfNamingStandard: 'PDF-Filenaming-Standard umgehen',
  overridePrintSettings: 'Druckeinstellungen überschreiben',
  overrideQuoteForm: 'Angebotsformular überschreiben',
  overrideSvgOpacity: 'SVG-Transparenz überschreiben',
  overrideWarning: 'Durch das Importieren von Daten wird Ihre aktuelle Stückliste ersetzt',
  owner: 'Inhaber | Inhaber',
  page: 'Seite | Seiten',
  pageBomPartsDeleted: '{count} Teile auf der BOM-Seite werden nicht mehr über {filename} zugänglich sein.',
  pageBuilder: 'Seiten-Builder',
  pageBulkErrorTooManyBooks: 'Begrenzen Sie die ausgewählte Anzahl von Büchern auf nicht mehr als 1000',
  pageBulkInsertBooksConfirmInsertAfter: 'Hierdurch wird {replacement} nach {original} in {whereUsedBookCount} {bookUnits} eingefügt.',
  pageBulkInsertBooksConfirmInsertBefore: 'Hierdurch wird {replacement} vor {original} in {whereUsedBookCount} {bookUnits} eingefügt.',
  pageBulkInsertBooksConfirmInsertReplace: 'Hierdurch wird {replacement} in {whereUsedBookCount} {bookUnits} eingefügt und {original} entfernt.',
  pageBulkInsertConfirmInsertAfter: 'Hierdurch wird {replacement} nach {original} in {whereUsedBookCount} {bookUnits} und {whereUsedTemplateCount} {templateUnits} eingefügt.',
  pageBulkInsertConfirmInsertBefore: 'Hierdurch wird {replacement} vor {original} in {whereUsedBookCount} {bookUnits} und {whereUsedTemplateCount} {templateUnits} eingefügt.',
  pageBulkInsertConfirmInsertReplace: 'Hierdurch wird {replacement} in {whereUsedBookCount} {bookUnits} und {whereUsedTemplateCount} {templateUnits} eingefügt und {original} entfernt.',
  pageBulkInsertConfirmTitle: 'Möchten Sie die Masseneinfügung durchführen?',
  pageBulkInsertDiscard: 'Ihre Masseneinfügung wird nicht durchgeführt.',
  pageBulkInsertHelpText: 'Mit dieser Funktion können Sie die Quellseite {thisDisplayName} in ausgewählte Teile-Bücher einfügen, die bereits eine andere Seite {originalDisplayName} enthalten. Wahlweise können Sie {originalDisplayName} auch von diesen Büchern entfernen.',
  pageBulkInsertInsertAfter: '{replacement} NACH {original} einfügen',
  pageBulkInsertInsertBefore: '{replacement} VOR {original} einfügen',
  pageBulkInsertInsertReplace: '{replacement} einfügen und {original} ENTFERNEN',
  pageBulkInsertScopeAll: 'Alle {type}, die die Zielseite haben {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Keine der {type}, die die Zielseite haben{originalDisplayName}',
  pageBulkInsertScopeSome: 'Einige der {type}, die die Zielseite haben{originalDisplayName}',
  pageBulkInsertStep1: 'Schritt 1: Finden Sie die gewünschte Zielseite',
  pageBulkInsertStep2: 'Schritt 2: Bestimmen Sie, wie die Seiten eingefügt oder ersetzt werden',
  pageBulkInsertStep3: 'Schritt 3: Wählen Sie die Bücher, in die die Masseneinfügung durchgeführt werden soll.',
  pageBulkInsertStep4: 'Schritt 4: Wählen Sie die Vorlagen, in die die Masseneinfügung durchgeführt werden soll.',
  pageBulkInsertSuccessBody: 'Änderungen des Inhaltsverzeichnisses des Buches erfolgen sofort. Die Suchresultate ändern sich, nachdem die Indizierung abgeschlossen ist.',
  pageBulkInsertSuccessTitle: 'Masseneinfügungsauftrag wurde übermittelt',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Hierdurch wird {replacement} nach {original} in {whereUsedTemplateCount} {templateUnits} eingefügt.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Hierdurch wird {replacement} vor {original} in {whereUsedTemplateCount} {templateUnits} eingefügt.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Hierdurch wird {replacement} in {whereUsedTemplateCount} {templateUnits} eingefügt und {original} entfernt.',
  pageComposer: 'Page Composer',
  pageCreated: 'Seite Erstellt',
  pageDeleteMessage: 'Das Löschen einer Seite erfolgt umgehend in der Bibliothek und im Inhalt-Admin. Das gelöschte Teil kann weiterhin gesucht werden, bis die Neuindizierung innerhalb weniger Minuten erfolgte.',
  pageDeleteMessage2: 'Diese Aktion kann ohne Hilfe des Documoto-Supports nicht rückgängig gemacht werden. Nach 90 Tagen werden der gelöschte Datensatz und alle Verknüpfungen dauerhaft gelöscht.',
  pageDescription: 'Seitenbeschreibung',
  pageDraftsDeleted: 'Mit dieser Seite verknüpfte Seitenentwürfe werden dauerhaft gelöscht.',
  pageFile: 'Auslagerungsdatei',
  pageFileRequired: 'Eine Auslagerungsdatei ist erforderlich.',
  pageFilename: 'Seiten-Dateiname',
  pageFilenameDeleted: '{filename} wird gelöscht.',
  pageFit: 'Seitenanpassung',
  pageHeader: 'Seitenkopf',
  pageLabel: 'Seite | Seiten',
  pageLayout: 'Seitenlayout',
  pageName: 'Seitenname',
  pagePart: 'Seitenteil | Seitenteile',
  pagePartData: 'Seitenteildaten',
  pagePartLevelDetails: 'Seite Teil bestellbar/sichtbar, Seite Teile-Tags',
  pagePartNumberVisible: 'Seiten-Teilenummer Sichtbar',
  pagePartOrderable: 'Seiten-Teil Bestellbar',
  pagePartOrderableDescription: 'Teil von dieser Seite Bestellbar',
  pagePartTag: 'Seiten-Teiletag | Seiten-Teiletags',
  pagePartVisibleDescription: 'Teilenummer auf dieser Seite sichtbar',
  pageToPartCollectionFailure: 'Seite {name} konnte nicht als Teilesammlung hinzugefügt werden.',
  pageUpdated: 'Seite Aktualisiert',
  pageUsageDataCouldNotBeLoaded: 'Seitennutzungsdaten konnten nicht geladen werden',
  pageViewer: 'Seitenübersicht',
  pageWidth: 'Seitenbreite',
  pagesWhereUsed: 'Seiten-Verwendungsnachweis',
  parentName: 'Name des Mutterunternehmens | Namen der Mutterunternehmen',
  part: 'Teil | Teile',
  partCode: 'Teilecode | Teilecodes',
  partCodeAddError: 'Teilecode(s) können nicht hinzugefügt werden',
  partCodeErrorEmpty: 'Konnte nicht gespeichert werden: Das Teilecode-Feld darf nicht leer sein',
  partCodeErrorInUse: 'Dieser Teilecode wird von Teilen in Documoto verwendet und darf nicht gelöscht werden. Kontaktieren Sie Documoto Support unter support{\'@\'}documoto.com.',
  partCodeErrorNotFound: 'Diese Teilecodes konnten nicht gelöscht werden, weil sie nicht gefunden wurden. Bitte stellen Sie sicher, dass Sie alle Änderungen gespeichert haben.',
  partCodesManager: 'Teilecodes-Manager',
  partCodesMessage: 'Teilecodes können anstelle von Teilenummern verwendet werden und werden häufig verwendet, um anzuzeigen, wenn Elemente der Stückliste veraltet, nicht verfügbar oder nur Referenzelemente sind (z. B. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Teilesammlung | Teilesammlungen',
  partCollectionsDescription: 'Fügen Sie bis zu 20 {parts} {pages} hinzu, um sie als {collections} auf dieser {productPage} anzuzeigen.',
  partCollectionsDescription2: 'Die ausgewählten {collections} bestimmen, welche {parts} den Endbenutzern für den Schnellzugriff oder die Bestellung zur Verfügung stehen.',
  partCollectionsDescription3: 'Die unten festgelegte Reihenfolge bestimmt, wie sie im Bibliotheks-{productPage}-Viewer angezeigt werden.',
  partCollectionsLimitError: 'Maximal {limit} {item1} sind pro {item2} erlaubt.',
  partCreated: 'Teil Erstellt',
  partData: 'Teiledaten',
  partDebouncerEmailQueueJob: 'E-Mail-Warteschlange',
  partDescription: 'Teile-Beschreibung',
  partEquipmentVerificationBanner: 'Banner zur Teileausrüstungsbestätigung',
  partLabel: 'Teil | Teile',
  partLevelDetails: 'Teilepreise, bestellbar/sichtbar, zusätzliche Übersetzungen, Teile-Tags',
  partName: 'Teilename',
  partNumber: 'Teilenummer',
  partNumberCopied: '{label} in die Zwischenablage kopiert',
  partNumberDescription: 'Die interne Teilenummer, nach der Endbenutzer suchen können',
  partNumberSupercededBy: '{partNumber} existiert als SupersededPartNumber-Tag auf ...',
  partNumberVisible: 'Teilenummer Sichtbar',
  partNumberVisibleDescription: 'Teilenummer ist für Endbenutzer sichtbar',
  partNumberVisibleLocal: 'Ist auf dieser Seite sichtbar',
  partNumberVisibleLocalBlocked: 'Teilenummer ist nicht Global Sichtbar',
  partOrderable: 'Teil Bestellbar',
  partRequired: 'Es wird mindestens ein Teil benötigt',
  partTag: 'Teiletag | Teiletags',
  partTagProperty: 'Eigenschaft des Teil-Tags | Eigenschaften des Teil-Tags',
  partUpdated: 'Teil aktualisiert',
  partVerificationInstructions: 'Bestätigen, dass dieses Teil zu Ihrer Ausrüstung passt',
  partialSupport: 'Teile-Support',
  partnerApiKey: 'Partner-API-Schlüssel',
  partnerRESTRequestLimit: 'Partner-REST-Anfragelimit',
  partsBook: 'Teilekatalog | Teilekataloge',
  partsBulkImport: {
    description: 'Laden Sie Ihre Datendatei hoch, um die Bulk-Import-Verarbeitung von Teilen zu starten. Unterstütztes Dateiformat: xlsx.',
    downloadTemplate: 'xlsx-Vorlage herunterladen',
    downloadUnprocessedRows: 'Unverarbeitete Zeilen-Tabelle herunterladen',
    hideRequirements: 'xlsx-Anforderungen ausblenden',
    overwriteTagValues: 'Tag-Werte für übereinstimmende Tags überschreiben',
    overwriteTranslations: 'Übereinstimmende Übersetzungen überschreiben',
    requirements: {
      discountPrice: {
        description: 'Legt den Rabattpreis auf Mandantenebene fest.'
      },
      enUSDescription: {
        description: 'Sprachspezifische Übersetzungsbeschreibung für ein Teil. Siehe unseren <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">-Leitfaden zur Sprachunterstützung</a>.'
      },
      enUSName: {
        description: 'Sprachspezifischer Übersetzungsname für ein Teil. Für neue Teile ist mindestens eine Übersetzung erforderlich. Siehe unseren <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">-Leitfaden zur Sprachunterstützung</a>.'
      },
      orderable: {
        description: 'Bestimmt, ob das Teil bestellt werden kann. Zulässige Werte sind `true` und `false`.Standardwert ist `true`.'
      },
      orgDiscountPrice: {
        description: 'Legt den Rabattpreis auf Organisationsebene für eine definierte Organisation fest. Spaltenüberschrift-Beispiel: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Legt den Einzelhandelspreis auf Organisationsebene für eine definierte Organisation fest. Spaltenüberschrift-Beispiel: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Legt den Großhandelspreis auf Organisationsebene für eine definierte Organisation fest. Spaltenüberschrift-Beispiel: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Eine eindeutige Bezeichnung für das Teil.'
      },
      retailPrice: {
        description: 'Legt den Einzelhandelspreis auf Mandantenebene fest.'
      },
      supplier: {
        description: 'Der Name des Teilelieferanten.'
      },
      tagInternalName: {
        description: 'Weist dem Teil Tags zu. Die Spaltenüberschrift muss der interne Name des Tags sein. Verwenden Sie für mehrere Werte das Trennzeichen &#124;. Beispiel: Rot&#124;Grün&#124;Blau.'
      },
      thumbnail: {
        description: 'Vorschaubild-Dateiname. Zulässige Dateiendungen: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Maßeinheit (z. B. "each", „Stück“).'
      },
      visible: {
        description: 'Bestimmt, ob das Teil sichtbar ist. Zulässige Werte sind `true` und `false`.Standardwert ist `true`.'
      },
      wholesalePrice: {
        description: 'Legt den Großhandelspreis auf Mandantenebene fest.'
      }
    },
    showRequirements: 'xlsx-Anforderungen anzeigen',
    submitNote: 'Durch Klicken auf „Submit“ (Absenden) wird ein Hintergrundprozess gestartet und Sie werden zur Seite „Job Manager“ (Jobmanager) weitergeleitet.',
    success: 'Auftrag für Teile-Bulk-Import erstellt',
    title: 'Import von Bulk-Teilen'
  },
  partsColumns: 'Teile-Spalten',
  partsDisplay: 'Teileanzeige',
  partsList: 'Teileliste',
  partsListColumn: 'Teilelisten-Spalte | Teilelisten-Spalten',
  partsListData: 'Teilelisten-Daten',
  partsListGridHeader: 'Überschrift der Teilelisten-Tabelle',
  partsNotSelected: 'Standardbild wird für Teile-Miniaturansicht verwendet. Wenn keine benutzerdefinierte Miniaturansicht verwendet wird, zeigt Documoto eine Standard-Miniaturansicht an.',
  partsPage: 'Teileseite | Teileseiten',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Teile-Spalten konnten nicht geladen werden',
    columnsUpdateErrorMsg: 'Beim Aktualisieren der Teile-Spalten ist ein Fehler aufgetreten',
    columnsUpdateSuccessMsg: 'Teile-Spalten wurden aktualisiert',
    cropWhitespaceOnImages: 'Weiße Ränder an Bildern entfernen',
    excludePartCodesFromPartsLists: 'Keine Teilecodes von den Teilelisten einbeziehen',
    highlightAlternateRows: 'Jede Zweite Reihe markieren',
    keepBOMOnRight: 'Stückliste weiter auf der Rechten Seite anzeigen',
    keepImagesOnLeft: 'Bilder weiter auf der Linken Seite anzeigen',
    printBorderAroundImages: 'Rand um Bilder Herum drucken',
    printHotpointsOnImages: 'Hotpoints auf den Bildern Drucken',
    rotateImagesAutomatically: 'Bilder Automatisch drehen'
  },
  partsPages: 'Teile-Seiten',
  password: 'Passwort',
  passwordBlankMessage: 'Passwort darf nicht leer sein',
  passwordCannotBeSame: 'darf nicht dasselbe wie Ihr derzeitiges Passwort sein',
  passwordCasingMassage: 'muss mindestens einen Klein- und einen Großbuchstaben enthalten',
  passwordCriteriaInfo: 'Ihr neues Passwort muss die folgenden Kriterien erfüllen:',
  passwordExpiredHeader: 'Passwort abgelaufen',
  passwordExpiredInfo: 'Ihr Passwort ist abgelaufen. Ihr neues Passwort muss die folgenden Kriterien erfüllen:',
  passwordLowerCaseMessage: 'Passwort muss mindestens einen Kleinbuchstaben enthalten',
  passwordMinLengthMessage: 'Passwörter müssen mindestens 8 Zeichen enthalten',
  passwordNotMatchingMessage: 'Passwörter stimmen nicht überein',
  passwordOptions: 'Passwortoptionen',
  passwordOptionsRequired: 'Passwortoptionen darf nicht leer sein',
  passwordSpecialCharactersMessage: 'Passwort muss mindestens ein Sonderzeichen enthalten',
  passwordUpperCaseMessage: 'Passwort muss mindestens einen Großbuchstaben enthalten',
  passwordWillExpire1Day: 'Das Anmelde-Passwort läuft nach weniger als 1 Tag ab',
  passwordWillExpire5Days: 'Das Anmelde-Passwort läuft nach weniger als 5 Tagen ab',
  passwordsMatch: 'Kennwortabgleich',
  pdfImport: {
    aiPdfImports: 'KI-PDF-Imports',
    aiPdfImportsDescription: 'KI-PDF-Imports für die automatisierte Inhaltsverarbeitung verwalten',
    createImport: 'Neuer KI-PDF-Import',
    createImportDescription: 'Wählen Sie eine PDF-Quelldatei aus und konfigurieren Sie die Einstellungen für die Extraktion. Dateibeschränkungen: bis zu 500 MB Größe und bis zu 3000 Seiten.',
    defaultPartNumberCode: 'Standard-Teilenummer-Code',
    defaultTranslationLocale: 'Standard-Übersetzungssprache',
    defaultUomHelpText: 'Wird verwendet, wenn eine Maßeinheit-Spalte nicht zugeordnet ist oder wenn eine extrahierte Stücklistenzeile keinen UOM-Wert enthält.',
    defaultUomRequired: 'Erforderlich, sofern kein UOM-Wert angegeben ist',
    dropFileMessage: 'Datei hier ablegen oder zum Hochladen klicken',
    fileSizeError: 'Dateigröße überschreitet das Limit von 500 MB',
    importCreatedError: 'Fehler beim Erstellen des Imports',
    importCreatedSuccess: 'Import erfolgreich erstellt und zur Verarbeitung in die Warteschlange eingereiht',
    mapColumnToTag: 'Spalte dem Seiten-Teile-Tag zuordnen',
    monthlyLimitExceeded: 'Das monatliche Seitenlimit für KI-PDF-Imports würde überschritten. Wenden Sie sich an Ihren Customer Success Manager, um Unterstützung zu erhalten.',
    pageNumberFilterInvalidRange: 'Ungültiger Seitenzahlenbereich',
    pageNumberFilterPlaceholder: 'z. B. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Teilenummer-Code gilt für Stücklistenzeilen, bei denen der Teilenummer-Wert leer ist',
    pdfImport: 'PDF-Import | PDF-Imports',
    pdfImportsDescription: 'KI-gestützte PDF-Imports zur automatischen Extraktion von Teiledaten aus PDF-Dokumenten verwalten',
    publishModalFooterHelp: 'Durch Klicken auf „Veröffentlichen“ wird ein Hintergrundauftrag in die Warteschlange eingereiht und gestartet. Sie werden zur Verwaltungsseite für KI-PDF-Imports zurückgeleitet, auf der Sie den Veröffentlichungsstatus verfolgen können.',
    publishSkipAutoHotpointing: 'Automatische Hotpoint-Erstellung für Seite überspringen | Automatische Hotpoint-Erstellung für Seiten überspringen',
    publishingFinishedNone: 'Veröffentlichung von Import "{importName}" abgeschlossen. Es wurden keine Seiten veröffentlicht.',
    publishingFinishedPartial: 'Veröffentlichung von Import "{importName}" abgeschlossen. {success} Seite veröffentlicht, {failed} Seite fehlgeschlagen. | Veröffentlichung von Import {importName} abgeschlossen. {success} Seiten veröffentlicht, {failed} Seiten fehlgeschlagen.',
    publishingFinishedSuccess: 'Veröffentlichung von Import "{importName}" abgeschlossen. {count} Seite veröffentlicht. | Veröffentlichung von Import {importName} abgeschlossen. {count} Seiten veröffentlicht.',
    reviewStatusAll: 'Status: Alle',
    reviewStatusApproved: 'Genehmigt',
    reviewStatusDropped: 'Ausgelassen',
    reviewStatusNoStatus: 'Kein Status',
    reviewStatusNone: 'Keine',
    reviewStatusPending: 'Ausstehend',
    selectPagePartTag: 'Seiten-Teile-Tag auswählen',
    statusDeclined: 'Abgelehnt',
    statusFailed: 'Fehlgeschlagen',
    statusPending: 'Ausstehend',
    statusProcessing: 'Wird bearbeitet',
    statusPublished: 'Veröffentlicht',
    statusPublishing: 'Wird veröffentlicht',
    submitNote: 'Durch Klicken auf „Senden“ wird ein Hintergrundauftrag in die Warteschlange eingereiht und gestartet. Sie werden zur Verwaltungsseite für KI-PDF-Imports zurückgeleitet, auf der Sie den Importstatus verfolgen können.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Abgleichstatus',
    columnPagePartTag: 'Seiten-Teile-Tag',
    columnPartNameWithLocale: 'Teilename ({locale})',
    emptyState: 'Keine BOM-Artikel gefunden',
    existingPartNameApplied: 'Vorhandene Teiledaten angewendet',
    title: 'Stückliste'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Abbildungsgrenzen anpassen',
    boundsAdjusted: 'Grenzen angepasst',
    emptyState: 'Keine Abbildungen für diese Seite.',
    hiresUnavailableError: 'Für diese Seite ist kein hochauflösendes Bild verfügbar.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Ausgewählte genehmigen ({count})',
    actionClearStatusSelected: 'Status für Ausgewählte löschen ({count})',
    actionCopySelected: 'In die erste ausgewählte Seite zusammenführen',
    actionDeleteImport: 'KI-PDF-Import löschen',
    actionDropSelected: 'Ausgewählte auslassen ({count})',
    actionPendingSelected: 'Ausgewählte auf „Ausstehend“ setzen ({count})',
    actionPublishSelected: 'Ausgewählte veröffentlichen',
    autoMergeAction: 'Seiten automatisch zusammenführen',
    autoMergeConfirmHelp: 'Seiten automatisch zusammenführen findet Seiten mit demselben Seitennamen und führt jede übereinstimmende Gruppe in der visuellen Reihenfolge in die erste Seite zusammen. In eine Zielseite zusammengeführte Quellseiten werden als „Ausgelassen“ markiert. Überprüfen Sie die Ergebnisse vor dem Veröffentlichen.',
    autoMergeConfirmTitle: 'Seiten mit übereinstimmenden Namen automatisch zusammenführen?',
    autoMergeFailed: 'Automatische Zusammenführung fehlgeschlagen, es wurden keine Änderungen vorgenommen',
    autoMergeSuccess: 'Automatische Zusammenführung abgeschlossen: {count} Gruppe(n) zusammengeführt, {dropped} Seite(n) ausgelassen',
    composedPageIndicator: 'Diese Seite enthält Inhalte, die von anderen PDF-Seiten kopiert wurden.',
    contentTypeAll: 'Alle Inhaltstypen',
    contentTypeBomOnly: 'Nur BOM',
    contentTypeBoth: 'Sowohl BOM als auch Abbildungen',
    contentTypeEmpty: 'Leere Seiten',
    contentTypeFilterLabel: 'Inhaltstyp',
    contentTypeIllustrationsOnly: 'Nur Abbildungen',
    importSettings: 'Importeinstellungen',
    includeDroppedPagesLabel: 'Ausgelassene Seiten einschließen',
    incompleteBomFilterLabel: 'Seiten mit unvollständiger BOM anzeigen',
    mergeConfirmSourcePages: '{count} Quellseite ausgewählt: | {count} Quellseiten ausgewählt:',
    mergeConfirmTitle: 'Ausgewählte Seiten in die erste ausgewählte Seite zusammenführen?',
    mergeConfirmTarget: 'Zielseite: {pageLabel}',
    mergeFailed: 'Fehler beim Zusammenführen der Seiten in die erste ausgewählte Seite',
    mergeSuccess: 'Seiten in {pageLabel} zusammengeführt ({bomCount} BOM-Artikel, {illustrationCount} Abbildungen)',
    noPages: 'Keine Seite(n) verfügbar',
    noPagesHint: 'Dieser Import enthält keine Seite(n)',
    noResults: 'Keine übereinstimmenden Seiten gefunden',
    noResultsHint: 'Versuchen Sie, Ihre Suche oder Filter anzupassen',
    notificationLoadFailed: 'Fehler beim Laden der Übersicht',
    notificationReviewStatusUpdated: '{count} Seite(n) erfolgreich aktualisiert',
    notificationSelectAllFailed: 'Fehler beim Auswählen aller Seiten',
    notificationUpdateReviewStatusFailed: 'Prüfstatus konnte nicht aktualisiert werden',
    publishBookIdentifierNotUnique: 'Buch-Identifikator muss eindeutig sein.',
    publishBookIdentifierTakenHelp: 'Ein Buch mit diesem Identifikator existiert bereits.',
    publishFailed: 'Fehler beim Veröffentlichen der ausgewählten Seite(n)',
    publishModalTitle: 'Ausgewählte Seiten veröffentlichen',
    publishNewBookHelpText: 'Erfolgreich veröffentlichte Seiten werden dem neuen Buch in derselben Reihenfolge hinzugefügt, in der sie in der KI-PDF-Importübersicht erscheinen. Ein neues Buch wird nur dann erstellt, wenn mindestens eine ausgewählte Seite erfolgreich veröffentlicht wurde.',
    publishNewBookIdentifierLabel: 'Buch-Identifikator',
    publishOptionNewBook: 'Neues Buch erstellen und Seiten hinzufügen',
    publishOptionPagesOnly: 'Nur Seiten veröffentlichen',
    reviewManagement: 'Prüfungsmanagement',
    reviewManagementTooltip: 'Verwenden Sie Prüfstatus, um Ihre Arbeit bei der Überprüfung extrahierter Inhalte zu organisieren. „Genehmigt“, „Ausstehend“ und „Ausgelassen“ haben keinen Einfluss auf die Veröffentlichung. Sie dienen nur zur Verfolgung des Prüffortschritts.',
    reviewProgress: 'Prüffortschritt',
    title: 'Übersicht'
  },
  pdfImportPageDetails: {
    actionPublish: 'Seite veröffentlichen',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    matchingPageNewPage: 'Neue Ersatzteilseite',
    matchingPageNewPageSharedSvg: 'Neue Ersatzteilseite, aber SVG-Datei, die mit (einer) anderen Seite(n) geteilt wird',
    matchingPageOpenExisting: 'Bestehende Seite öffnen',
    matchingPageOverwrite: 'Bestehende Ersatzteilseite wird überschrieben',
    navLabel: 'KI-PDF-Importübersicht',
    navigationFailedText: 'Fehler beim Navigieren zu Seite {pageNumber}',
    nextPage: 'Nächste Seite',
    notificationLoadFailed: 'Fehler beim Laden der Seite',
    notificationPublishFailed: 'Fehler beim Übermitteln des Veröffentlichungsauftrags',
    notificationSaveFailed: 'Fehler beim Speichern der Seite',
    notificationSaveSuccess: 'Seite erfolgreich gespeichert',
    pageOriginComposed: 'Besteht aus mehreren PDF-Seiten',
    pageOriginExtracted: 'Aus einer PDF-Seite extrahiert',
    pageOriginLabel: 'Seitenherkunft',
    previousPage: 'Vorherige Seite',
    publishPageModalHelpText: 'Diese Ersatzteilseite wird außerhalb eines Buchkontexts veröffentlicht. Die Veröffentlichung erstellt eine neue Ersatzteilseite oder überschreibt eine bestehende, basierend auf den Regeln zur Identität von Seiten.',
    thumbnailCardTitle: 'PDF-Seiten-Vorschaubild',
    viewBom: 'Stückliste'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Erstellt',
    columnPdfPage: 'PDF-Seite(n)',
    columnPublishingStatus: 'Veröffentlichungsstatus',
    detailLoadFailed: 'Fehler beim Laden der Details zum Veröffentlichungsauftrag',
    emptyBookOperations: 'In diesem Auftrag wurden keine Buch-Operationen durchgeführt.',
    emptyJobsHint: 'Veröffentlichungsaktivitäten werden hier angezeigt, nachdem Seiten veröffentlicht wurden.',
    emptyJobsTitle: 'Für diesen KI-PDF-Import wurde(n) noch kein(e) Veröffentlichungsauftrag/-aufträge ausgeführt.',
    emptyPagesTitle: 'Keine Seite(n) entspricht/entsprechen dem ausgewählten Filter.',
    filterAllPages: 'Alle Seiten anzeigen',
    filterFailedOnly: 'Nur fehlgeschlagene Seiten anzeigen',
    filterNameQuery: 'Name oder Seitendatei',
    filterPublishedOnly: 'Nur veröffentlichte Seiten anzeigen',
    helpText: 'Diese Seite zeigt den Verlauf der aus diesem KI-PDF-Import veröffentlichten Teile-Seiten, einschließlich der Seiten, die während der Veröffentlichung erstellt, überschrieben oder fehlgeschlagen sind.',
    jobLabel: 'Auftrag Nr.{number}',
    loadFailed: 'Fehler beim Laden des Veröffentlichungsverlaufs',
    resultPublishedCreated: 'Veröffentlicht – Erstellt',
    resultPublishedUpdated: 'Veröffentlicht – Überschrieben',
    resultSummaryBookCreated: 'Ein neues Buch wurde erstellt.',
    resultSummaryNone: 'Keine Seiten veröffentlicht.',
    resultSummaryPagesFailed: '{n} Seite fehlgeschlagen. | {n} Seiten fehlgeschlagen.',
    resultSummaryPagesPublished: '{n} Seite veröffentlicht. | {n} Seiten veröffentlicht.',
    statusFailed: 'Fehlgeschlagen',
    statusInProgress: 'Wird durchgeführt',
    title: 'Veröffentlichungsverlauf'
  },
  permission: 'Berechtigung | Berechtigungen',
  phoneNumber: 'Telefonnummer',
  phoneNumberExt: 'Dw.',
  phonePrimary: 'Haupttelefonnummer',
  phoneSecondary: 'Zweite Telefonnummer',
  pinFilter: 'Filter anheften, um die Ergebnisseite zu durchsuchen',
  pinned: 'Angepinnt',
  plusMoreOrgs: '+ {totalOrgCount} zusätzliche Organisationen',
  polishDescription: 'Polnische Beschreibung',
  polishName: 'Polnischer Name',
  populatePdfNameSelection: 'PDF-Dateinamen-Auswahl ausfüllen',
  populatePdfNameWith: 'PDF-Dateinamen ausfüllen mit',
  port: 'Port',
  portrait: 'Porträt',
  portugueseDescription: 'Portugiesische Beschreibung',
  portugueseName: 'Portugiesischer Name',
  postComment: 'Kommentar veröffentlichen',
  postalCode: 'Postleitzahl',
  poweredBy: 'Unterstützt durch',
  preferences: 'Präferenzen',
  preferencesDisable: 'Benutzerpräferenzen deaktivieren',
  prefix: 'Präfix | Präfixe',
  preview: 'Vorschau',
  previewOfName: 'Vorschau von {name}',
  pricing: 'Preisgestaltung',
  pricingDiscountEnabled: 'Reduzierten Preis anzeigen',
  pricingDisplayInCart: 'Preise im Warenkorb anzeigen',
  pricingDisplayInPartsList: 'Preise in Teileliste anzeigen',
  pricingGlobal: 'Globale Preisgestaltung',
  pricingGlobalDescription: 'Der normale Preis, wenn er von der Organisation nicht überschrieben wird',
  pricingHideInitially: 'Preis anfangs ausblenden',
  pricingHidePricingButton: 'Schaltfläche Preis Verbergen aktivieren',
  pricingHidePricingButtonDisable: 'Schaltfläche Preis Verbergen deaktivieren',
  pricingHidePricingButtonDisableHelp: 'Das Deaktivieren der Schaltfläche „Preise ausblenden“ entfernt die Fähigkeit der Benutzer, Preisstufen ein- oder auszublenden. Jede Preisstufe, die als „Preis anfangs ausblenden“ konfiguriert ist, bleibt ausgeblendet und Benutzer können sie nicht anzeigen.',
  pricingOrganization: 'Preisgestaltung der Organisation',
  pricingOrganizationDeleteConfirm: 'Sind Sie sicher, dass Sie die Preisgestaltung der Organisation löschen möchten?',
  pricingOrganizationDescription: 'Die Preisgestaltung der Organisation überschreibt die globale Preisgestaltung für alle Benutzer innerhalb einer Organisation und ihrer Tochterunternehmen.',
  pricingOrganizationDuplicate: 'Diese Organisation wird bereits überschrieben',
  pricingOrganizationEmptyState: 'Es wurden keine Überschreibungen für Organisationen definiert. Klicken Sie auf {add}, um zu beginnen.',
  pricingRetailEnabled: 'Verkaufspreis anzeigen',
  pricingWholesaleEnabled: 'Großhandelspreis anzeigen',
  primary: 'Primär',
  print: 'Drucken',
  printJob: 'Druckauftrag',
  printLogo: 'Logo Drucken',
  printSetting: 'Druckeinstellungen',
  printSettingCopyMessage: 'Geben Sie einen Namen für die neue Druckeinstellung ein.',
  printSettingCreated: 'Druckeinstellung erstellt',
  printSettingDeleteFail: 'Druckeinstellungen konnten nicht Gelöscht werden',
  printSettingEmptyMessage: 'Es wurden keine Druckeinstellungen definiert. Fügen Sie eine Druckeinstellung hinzu, um zu beginnen.',
  printSettingSaveFail: 'Druckeinstellungen konnten nicht Gespeichert werden',
  printSettingSelectionRequired: 'Auswahl der Druckeinstellungen ist erforderlich.',
  printSettingSetDefaultSuccess: 'Standarddruckeinstellung eingestellt',
  printSettingUpdateFail: 'Druckeinstellung konnte nicht Aktualisiert werden',
  printSettings: 'Druckeinstellungen',
  printSettingsLogo: 'Druckeinstellungen-Logo',
  printerLane: 'Druckerspur',
  printing: 'Wird gedruckt',
  printingDisabled: 'Drucken deaktivieren',
  privacyPolicy: 'Datenschutzrichtlinie',
  proceed: 'Fortfahren',
  process: 'Verarbeiten',
  processContent: 'Content bearbeiten',
  processToDraft: 'Zu Entwurf verarbeiten',
  processedPlzToDraft: 'Zu Entwurf/Entwürfen verarbeitete PLZ(s)',
  processing: 'Wird bearbeitet',
  productCategory: 'Produktkategorie | Produktkategorien',
  productCategoryName: 'Name der Produktkategorie',
  productId: 'Produkt-ID',
  productIdErrorMessage: 'Eine Produkt-ID ist erforderlich',
  productIdMessage: 'Der Bezeichnerwert, den Benutzer verwenden, um das Produkt zu finden, z. B. „FTX1000“',
  productPage: 'Produktseite | Produktseiten',
  productPageAccessControlDescription: 'Zugriffskontrollen definieren, wer diese Seite entsprechend der Organisationen und zugewiesenen Benutzergruppen ansehen kann.',
  productPageCreated: 'Produktseite erstellt',
  productPageDescription: 'Beschreibung der Produktseite',
  productPageIdentifierMessage: 'Eine eindeutige interne Kennung für diese Seite',
  productPageName: 'Name der Produktseite',
  productPageProductId: 'Produkt-ID der Produktseite',
  productPageUpdated: 'Produktseite aktualisiert',
  productPagesBulkImport: {
    description: 'Laden Sie Ihre Datendatei hoch, um die Bulk-Import-Verarbeitung von Produktseiten zu starten. Unterstütztes Dateiformat: xlsx.',
    downloadUnprocessedRows: 'Unverarbeitete Zeilen-Tabelle herunterladen',
    overwriteAccessControls: 'Zugriffskontrollen (Organisationen und Benutzergruppen) überschreiben',
    overwriteAssociatedMedia: 'Zugehörige Medien überschreiben',
    requirements: {
      enUSCategory: {
        description: 'Bestehender Name der Produktkategorie für eine bestimmte Sprachversion. Siehe unseren <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">-Leitfaden zur Sprachunterstützung</a>.'
      },
      enUSDescription: {
        description: 'Sprachspezifische Übersetzungsbeschreibung für eine Produktseite. Siehe unseren <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">-Leitfaden zur Sprachunterstützung</a>.'
      },
      enUSName: {
        description: 'Sprachspezifischer Übersetzungsname für eine Produktseite. Für neue Produktseiten ist mindestens eine Übersetzung erforderlich. Siehe unseren <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">-Leitfaden zur Sprachunterstützung</a>.'
      },
      identifier: {
        description: 'Eine eindeutige Kennung für eine Produktseite, die nur im Admin Center sichtbar und durchsuchbar ist.'
      },
      media: {
        description: 'Liste von Medienkennungen, die mit einer bestimmten Produktseite verknüpft sind. Verwenden Sie bei mehreren Werten das Trennzeichen &#124;.'
      },
      organizations: {
        description: 'Liste von Organisationen mit Zugriff auf eine bestimmte Produktseite. Verwenden Sie bei mehreren Werten das Trennzeichen &#124;.'
      },
      productId: {
        description: 'Eine Produktseitenkennung für Endbenutzer, die in der Library sichtbar und durchsuchbar ist. Die Produkt-ID muss kein eindeutiger Wert sein.'
      },
      tagInternalName: {
        description: 'Weist einer Produktseite Tags zu. Die Spaltenüberschrift muss der interne Name des Tags sein. Verwenden Sie für mehrere Werte das Trennzeichen &#124;. Beispiel: Rot &#124; Grün &#124; Blau.'
      },
      thumbnail: {
        description: 'Vorschaubild-Dateiname. Zulässige Dateiendungen: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Liste von Benutzergruppen mit Zugriff auf eine bestimmte Produktseite. Verwenden Sie bei mehreren Werten das Trennzeichen &#124;.'
      }
    },
    success: 'Produktseiten-Bulk-Import erstellt',
    title: 'Produktseiten-Bulk-Import'
  },
  production: 'Produktion',
  professional: 'Professionell',
  profile: 'Profil',
  prohibitExportDownloadOfContent: 'Export/Herunterladen von Inhalten untersagen',
  prohibitExportDownloadOfContentHelpText: 'Durch die Einstellung \'Enable\' (Aktivieren) wird verhindert, dass Benutzer (mit Berechtigungen) diesen Inhalt exportieren oder herunterladen.',
  property: 'Eigenschaft| Eigenschaften',
  province: 'Region',
  'public': 'Öffentlich',
  publish: 'Veröffentlichen',
  publishDocuments: 'Dokumente Veröffentlichen',
  publishDraft: 'Entwurf Veröffentlichen',
  publishThumbnailJob: 'Miniaturansicht Veröffentlichen',
  publisher: 'Herausgeber | Herausgeber',
  publisherJob: 'Herausgeber-Auftrag',
  publisherLane: 'Herausgeberspur',
  publisherManualLane: 'Herausgeberhandbuch-Spur',
  publisherMessage: 'Inhaltserstellung, Verwaltung und Druckeinstellungen',
  publishingErrors: 'Veröffentlichungsfehler',
  publishingErrorsWithName: 'Veröffentlichungsfehler {name}',
  publishingInProgress: 'Publishing läuft. Sendung nicht möglich',
  purchaseOrder: 'Bestellung',
  purchaseOrderTemplateDisabled: 'Bestellvorlagen deaktivieren',
  purchaseOrderTemplateEnabled: 'Bestellvorlagen aktivieren',
  qty: 'Menge',
  quantity: 'Menge',
  query: 'Abfrage',
  quickAdd: 'Schnelles Hinzufügen',
  quickAddHelpText: 'Beginnen Sie mit der Eingabe, um Teile zu finden, die Sie in den Warenkorb legen können.',
  quickAddInCartEnabled: 'Schnelles Hinzufügen in den Warenkorb aktivieren',
  quickLinks: 'Quick-Links',
  quote: 'Angebot | Angebote',
  quoteFormType: 'Angebotsformular',
  quoteTemplateDisabled: 'Angebotsvorlagen deaktivieren',
  quoteTemplateEnabled: 'Angebotsvorlagen aktivieren',
  range: 'Bereich',
  rearrange: 'Neu ordnen',
  rebuildIndexJob: 'Index Neu Erstellen',
  recentSearches: 'Letzte Suchanfragen',
  recentlyAdded: 'Vor Kurzem Hinzugefügt',
  recentlyEdited: 'Vor Kurzem Bearbeitet',
  recentlyViewed: 'Vor Kurzem Angezeigt',
  recipientOrRecipients: 'Empfänger',
  rectangle: 'Rechteck',
  redirect: 'Umleiten',
  refresh: 'Aktualisieren',
  related: 'Zugehöriges',
  relatedDescription: 'Zugehörige Medien, die in der Bibliothek für diesen {type} vorhanden sind. Beachten Sie, dass die zugehörigen Medien Zugriffskontrollen haben müssen, damit die Benutzer sie in der Registerkarte \'Zugehöriges\' sehen können.',
  relatedInfo: 'Zugehörige Info',
  relatedView: 'Zugehörige Medien anzeigen',
  relationship: 'Beziehung | Beziehungen',
  releaseNotes: 'Freigabehinweise',
  remainingWidth: 'Übrige Breite',
  rememberMe: 'Anmeldeinformationen speichern',
  remove: 'Entfernen',
  removeAll: 'Alle entfernen',
  removeItemConfirmation: 'Sind Sie sicher, dass Sie {item} entfernen möchten?',
  removeItemCount: 'Wollen Sie {count} {type} wirklich löschen?',
  replace: 'Ersetzen',
  replaceExisting: 'Bestehendes ersetzen',
  report: 'Bericht | Berichte',
  reportAnIssue: 'Problem melden',
  reportAnIssueMessage: 'E-Mail erfolgreich gesendet.',
  reportCatalogName: 'Reportkatalog-Name',
  reportCatalogNotSet: 'Reportkatalog wurde für den Report nicht definiert.',
  reportDefinition: 'Report-Definition | Report-Definitionen',
  reportDefinitionDeleteError: 'Report-Definition konnte nicht gelöscht werden',
  reportExportTimeWarning: 'Je nach Anzahl der Einträge und ausgewähltem Format kann der Export mehrere Minuten erfordern.',
  reportSettings: 'Berichtseinstellungen',
  reporting: 'Wird gemeldet',
  reportingMessage: 'Zugriff auf verschiedene Berichte und Metriken',
  reportsEmptyState: 'Keine Reports',
  reportsLibrary: 'Berichtsbibliothek',
  requestForQuote: 'Angebotsanforderung',
  requestFormType: 'Angebotsformular',
  requireAuthentication: 'Authentifizierung erforderlich',
  required: 'Erforderlich',
  requiredField: 'Pflichtfeld',
  requiredItem: '{item} erforderlich.',
  requiredMessage: 'Ein {item} ist erforderlich',
  requiredMessageAndUnique: 'Ein {item} ist erforderlich und muss eindeutig sein.',
  requiredReading: 'Pflichtlektüre',
  requiredReadingMessage: 'Bitte prüfen Sie Folgendes:  ',
  requiredType: 'Ein Typ ist erforderlich.',
  requiredUrlMessage: 'Eine gut formatierte URL ist erforderlich.',
  reset: 'Zurücksetzen',
  resetPassword: 'Passwort zurücksetzen',
  resetPasswordError: 'Beim Zurücksetzen Ihres Passworts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  resetPasswordTokenError: 'Passwort-Wiederherstellungstoken ist ungültig.',
  resetZoom: 'Zoom Zurücksetzen',
  resize: 'Größe anpassen',
  resizeThumbnails: 'Größe von Thumbnails automatisch anpassen',
  resource: 'Ressource | Ressourcen',
  result: 'Ergebnis | Ergebnisse',
  resultFor: 'Ergebnis für {item} | Ergebnisse für {item}',
  retail: 'Einzelhandel',
  retailPrice: 'Verkaufspreis',
  retailTotal: 'Verkaufspreis Gesamt',
  'return': 'Zurückgehen',
  returnToItem: 'Zurück zu {item}',
  returnToMedia: 'Zurück zu Medien',
  returnToPartList: 'Zurück zur Teileliste',
  returnToTemplate: 'Zurück zur Vorlage',
  returnToViewer: 'Zurück zur Anzeige',
  revert: 'Rückgängig machen',
  revertChanges: 'Änderungen rückgängig machen',
  revertChangesMsg: 'Wollen Sie Ihre Änderungen wirklich rückgängig machen?',
  right: 'Rechts',
  romanianDescription: 'Rumänische Beschreibung',
  romanianName: 'Rumänischer Name',
  rootLevelBrowseFlow: 'Stammverzeichnis-Ebene',
  row: 'Reihe',
  russianDescription: 'Russische Beschreibung',
  russianName: 'Russischer Name',
  s3DataExportsEnabled: 'S3-Datenexporte aktivieren',
  sampleData: 'Beispieldaten',
  samplePreview: 'Muster-Vorschau',
  sandbox: 'Sandbox',
  sat: 'Sa.',
  save: 'Speichern',
  saveAndClose: 'Speichern und schließen',
  saveAndEditTarget: 'Ziel speichern und bearbeiten',
  saveChanges: 'Ihre Änderungen bei {item}? {name}',
  saveChangesToItem: 'Ihre Änderungen des {item} speichern?',
  saveNewAPIKey: 'Neuer Integrationsschlüssel wurde nicht Gespeichert, Zurückgehen, um die Einrichtung abzuschließen',
  saveNewWidgetKey: 'Neuer Widget-Schlüssel nicht gespeichert. Zurückkehren, um Einrichtung abzuschließen.',
  saveOrderAttachmentsError: 'Auftragsanhänge konnten nicht gespeichert werden.',
  saved: 'Gespeichert',
  search: 'Suchen',
  searchAllContent: 'Alle Inhalte durchsuchen',
  searchCategories: 'Kategorien',
  searchConfiguration: 'Suchkonfiguration',
  searchContent: '{content} suchen',
  searchCriteria: 'Suchkriterien',
  searchDocumoto: 'Documoto durchsuchen',
  searchFeatures: 'Suchfunktionen',
  searchFieldConfigDescription: 'Folgende Einstellungen für die Systemfeldsuche gelten nur für die allgemeine Suche in der Bibliothek, die Suchergebnisseite und das schnelle Hinzufügen im Warenkorb. Andere Suchfunktionen (z. B. Admin-Center-Suche und Bibliothek, wo verwendet) sind davon nicht betroffen.',
  searchInContent: 'Suchen in {contentName}...',
  searchPlaceholder: 'Alle Inhalte durchsuchen...',
  searchPrompt: 'Alle Inhalte durchsuchen...',
  searchProperty: 'Eigenschaft durchsuchen | Eigenschaften durchsuchen',
  searchResults: 'Suchergebnisse',
  searchResultsConfiguration: 'Konfiguration Suchergebnisse',
  searchSettings: 'Sucheinstellungen',
  searchSettingsDescription: 'Diese Einstellungen steuern das Verhalten, die Funktionen und die Ergebnisse der Bibliothekssuche.',
  searchTerm: 'Suchbegriff',
  searchTips: 'Suchtipps:',
  searchType: 'Typ',
  searchable: 'Durchsuchbar',
  searchableFieldsSuccessfullyUpdated: 'Durchsuchbare Felder erfolgreich aktualisiert.',
  searchableTag: 'Durchsuchbares Tag',
  searchingInLanguage: 'Suche erfolgt {lang} nur auf',
  searchingInTwoLanguages: 'Suche erfolgt nur auf {lang1} und {lang2}',
  section: 'Abschnitt',
  select: 'Auswählen',
  selectAField: '{field} auswählen',
  selectAll: 'Alle auswählen',
  selectAndClose: 'Auswählen und Schließen',
  selectChapters: 'Kapitel Auswählen',
  selectChildren: 'Tochterunternehmen auswählen',
  selectFields: '{field} auswählen',
  selectItem: '{item} wählen',
  selectMedia: 'Medien Auswählen',
  selectPage: 'Seite wählen',
  selectPages: 'Seite(n) Auswählen',
  selectTargetPage: 'Zielseite wählen',
  selected: 'Ausgewählt',
  selectedTargetPage: 'Gewählte Zielseite',
  send: 'Senden',
  sendReverificationEmail: 'Bestätigungsprüfungs-E-Mail senden',
  sendVerificationEmail: 'Bestätigungs-E-Mail senden',
  september: 'September',
  sequence: 'Sequenz',
  serbianDescription: 'Serbische Beschreibung',
  serbianName: 'Serbischer Name',
  serviceUri: 'Service URI',
  sessionLog: 'Sitzungsprotokoll',
  set: 'Einstellen',
  setAsDefault: 'Als Standard festlegen',
  setPassword: 'Passwort festlegen',
  settings: 'Einstellungen',
  settingsMessage: 'Aktualisieren Sie Ihre Benutzereinstellungen und Ihr Passwort',
  shape: 'Form',
  shapeTool: 'Formwerkzeug',
  shared: 'Gemeinsam genutzt',
  sharedCart: 'Gemeinsamer Warenkorb | Gemeinsame Warenkörbe',
  sharedCartDeleteContent: 'Damit wird der Gemeinsame Warenkorb für alle Organisationen entfernt, die ihn gemeinsam verwendeten.',
  sharedCartOrganizationContent: 'Wählen Sie die Organisationen, die den Gemeinsamen Warenkorb verwenden können.',
  sharedShoppingCartsEnabled: 'Gemeinsame Warenkörbe aktivieren',
  shoppingCartExportJob: 'Export des Einkaufswagens',
  shoppingCartLoadingLongTime: 'Der Einkaufswagen wird geladen. Die Einkaufswagensymbole werden verfügbar, sobald der Vorgang abgeschlossen ist. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Documoto-Administrator, um Unterstützung zu erhalten.',
  showChapterTOCForHiddenPages: 'Kapitel-Inhaltsverzeichnis für Verborgene Seiten anzeigen',
  showExportFromSearch: 'Exportieren der Suchergebnisse zulassen',
  showExportFromSearchHelp: 'Exportieren des bei der Suche gefundenen Bücherverzeichnisses zulassen',
  showHelp: 'Hilfe anzeigen',
  showIdentifierInLibrary: 'Medien- und Produktseiten-Kennungen in der Bibliothek anzeigen',
  showIdentifierInSearch: 'Medienkennung bei der Suche anzeigen',
  showItem: '{item} anzeigen',
  showLess: 'Weniger anzeigen',
  showMediaDescriptionFilter: 'Medienbeschreibungsfilter anzeigen',
  showMediaIdentifierFilter: 'Medienbezeichnungsfilter anzeigen',
  showMediaNameFilter: 'Mediennamensfilter anzeigen',
  showMore: 'Mehr anzeigen',
  showOnlyExactMatches: 'Nur exakte Übereinstimmungen anzeigen',
  showOrganizationFilter: 'Organisationsfilter anzeigen',
  showPartNameFilter: 'Teilenamenfilter anzeigen',
  showPartNumberFilter: 'Teilenummernfilter anzeigen',
  showRecentlyAdded: 'Vor Kurzem Hinzugefügtes anzeigen',
  showRecentlyViewed: 'Vor Kurzem Angezeigtes anzeigen',
  showSearchButton: 'Such-Schaltfläche für Startseite anzeigen',
  showSearchButtonHelp: 'Die Schaltfläche \'Zur Suche\' in der Kopfzeile der Bibliothek anzeigen',
  signature: 'Unterschrift',
  size: 'Größe',
  snapshot: 'Snapshot | Snapshots',
  solrSlaveSvrOverride: 'Basis-URLs der SOLR-Slave-Server überschreiben',
  sortAsc: '{value} A-Z',
  sortDesc: '{value} Z-A',
  sortRelevant: 'Am Relevantesten',
  sortType: 'Nach Typ sortieren',
  sourceBrowseFlow: 'Quellen-Browser-Ablauf',
  sourceFile: 'Quelldatei',
  sourceFilename: 'Quelldateiname',
  spanishDescription: 'Spanische Beschreibung',
  spanishName: 'Spanischer Name',
  square: 'Quadrat',
  ssoConfiguration: 'SSO-Konfiguration',
  ssoIdpMetadataUrl: 'SSO-IDP-Metadaten-URL',
  ssoLoginMaxAuthenticationAgeSeconds: 'Max. Authentifizierungsalter für SSO-Anmeldung in Sekunden',
  ssoSamlDnAttributeName: 'SSO-SAML-DN Attributname',
  ssoSamlEmailAttributeName: 'SSO-SAML-E-Mail Attributname',
  ssoSamlMemberofAttributeName: 'SSO-SAML-MemberOf Attributname',
  ssoSniForSsoMetadataRetrieval: 'SNI für SSO-Metadatenabruf verwenden ',
  standard: 'Standard',
  standardUserGroup: 'Standard-Benutzergruppe',
  startDate: 'Beginndatum',
  startDateRequired: 'Startdatum erforderlich.',
  state: 'Land',
  'static': 'Statisch',
  status: 'Status',
  statusCode: 'Status-Code | Status-Codes',
  stitchPages: 'Seiten anheften',
  storeFilterValues: 'Filterwerte speichern',
  storeFilterValuesDescription: 'Wenn diese Einstellung aktiviert wird, werden die Werte gespeichert, die Benutzer in den Filtern ihrer Suchseite für diesen Tag festgelegt haben.',
  storeFrontAdmin: 'Storefront Admin',
  storefront: 'Storefront',
  storefrontIntegration: 'Storefront-Integration | Storefront-Integrationen',
  storefrontIntegrationSubtitle: 'Diese Einstellungen steuern verschiedene Storefront-Integrationselemente und Optionen. Gehen Sie sorgfältig vor, wenn Sie Änderungen durchführen. Kontaktieren Sie Documoto Support für weitere Informationen.',
  storefrontSettings: 'Storefront-Einstellungen',
  storefrontSettingsDescription: 'Diese Einstellungen steuern verschiedene Storefront-Elemente und Optionen. Gehen Sie sorgfältig vor, wenn Sie Änderungen durchführen. Kontaktieren Sie Documoto Services für weitere Informationen.',
  storefrontSettingsOrgDescription: 'Diese Einstellungen steuern verschiedene Elemente und Optionen von Storefront auf Organisationsebene. Gehen Sie sorgfältig vor, wenn Sie Änderungen durchführen. Kontaktieren Sie Documoto Services für weitere Informationen.',
  stroke: 'Strich',
  style: 'Stil | Stile',
  styles: {
    colorHotpoint: 'Hotpoint-Standardeinstellung',
    inheritedFromOrg: 'Von Unternehmen {org} übernommen',
    inheritedFromSystem: 'Von der Systemvorgabe übernommen',
    inheritedFromTenant: 'Vom Mandanten übernommen',
    invalidHexcode: 'Ungültiger Hexadezimalcode',
    organization: 'Organisationsstil | Organisationsstile',
    organizationSaved: 'Organisationsstile gespeichert',
    sampleNavigation: 'Navigationsregisterkarten',
    samplePrimary: 'Navigation/Schaltflächen',
    sampleSelectedHotpoint: 'Ausgewählte Hotpoints',
    tenant: 'Mandantenstil | Mandantenstile',
    tenantSaved: 'Mandantenstile gespeichert'
  },
  subChapter: 'Unterkapitel | Unterkapitel',
  subject: 'Betreff',
  subjectMessage: 'Betreff erforderlich',
  submit: 'Senden',
  submitPurchaseOrder: 'Bestellung',
  submitRequestForQuote: 'Angebotsanforderung',
  submitted: 'Gesendet',
  submittedBy: 'Gesendet von',
  submittedFilesMessage: '{fileCount} Datei(en) gesendet.',
  submitter: 'Gesendet von',
  submitterEmail: 'E-Mail-Adresse des Einreichers',
  submitterFirstName: 'Vorname des Einreichers',
  submitterLastName: 'Nachname des Einreichers',
  submitterOrgName: 'Organisation des Einreichers',
  submitterUserName: 'Benutzername des Einreichers',
  success: 'Erfolg',
  successNotificationDuration: 'In den Warenkorb hinzufügen - Dauer der Erfolgs-Popup-Benachrichtigung',
  suffix: 'Suffix | Suffixe',
  suggestedKeywords: 'Vorgeschlagene Schlüsselwörter',
  suggestedResults: 'Vorgeschlagene Ergebnisse',
  suggestion: 'Vorschlag | Vorschläge',
  sun: 'So.',
  superAdminSettings: 'Superadmin-Einstellungen',
  superadmin: 'Superadmin',
  supersede: 'Ersetzen',
  supersedeComplete: 'Möchten Sie die Ersetzung durchführen?',
  supersedeDiscardChanges: 'Möchten Sie Ihre Ersetzung verwerfen?',
  supersedeMainText: 'Bei der Ersetzung wird ein bestehendes Teil durch ein oder mehrere andere Teile auf jeder Teileseite ersetzt, wo das alte Teil gefunden wird. Die alte Teilenummer wird gelöscht, kann aber über Tags noch gefunden werden, sodass Inhalte über die alte Nummer oder die neue(n) Nummer(n) gefunden werden können.',
  supersedeMessage: 'Aktualisierungen von Teilen sind sofort wirksam. Bei der Suche werden die Aktualisierungen innerhalb weniger Minuten reflektiert.',
  supersedeNotProcessed: 'Ihre Ersetzung wird nicht durchgeführt.',
  supersedeReplacePart: 'Finden Sie ein oder mehrere Teile, die das Teil ersetzen',
  supersedeSuccessful: 'Ersetzung war Erfolgreich',
  supersedeWith: 'Teil Durch... ersetzen',
  superseded: 'Ersetzt',
  supersededParts: 'Ersetzte Teile',
  supplier: 'Lieferant | Lieferanten',
  supplierDescription: 'Das Unternehmen, das dieses Teil liefert',
  supplierKey: 'Lieferantenschlüssel',
  supportedDraftArchives: 'Nicht unterstützte Datei; Entwurfsdateien werden unterstützt: MDZ, PLZ',
  supportedImageFormats: 'Unterstützte Bildformate: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Setzen Sie mehrere Suchbegriffe in Anführungszeichen, um eine genaue Übereinstimmung zu erzielen.',
  svgFinder: 'SVG Finder',
  swedishDescription: 'Schwedische Beschreibung',
  swedishName: 'Schwedischer Name',
  system: 'System',
  systemAdmin: 'System-Admin',
  systemFieldSearchAndFiltering: 'Systemfeldsuche & Filterung',
  systemFields: 'Systemfelder',
  systemName: 'Systemname',
  systemStatus: 'Systemstatus',
  systemVersion: 'System-Version',
  tabDelimited: 'durch Tabstopps getrennt',
  tableOfContents: 'Inhaltsverzeichnis',
  tabloid: 'Kleinformatige Zeitung',
  tag: 'Tag | Tags',
  tagDeleteAffectedCount: 'Damit wird das Tag gelöscht und die Tag-Informationen von {count} Elementen entfernt.',
  tagDeleteAffectedNone: 'Dieses Tag wird derzeit von keinem Element verwendet.',
  tagEditor: {
    filterPrompt: 'Die ersten 100 Werte werden angezeigt. Verwenden Sie den Filter, um mehr anzuzeigen.',
    rangeBoundLengthInvalid: 'Grenze darf nicht mehr als (limit) Ziffern enthalten.',
    tagEditorModal: 'Tag Editor Modal',
    textfieldHelpText: 'Geben Sie einen oder mehrere Werte ein, getrennt durch Semikolons. Beispiel: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Alle bestehenden Medien mit {deleteCategoryName} verlieren diese Kategorie nach dem Löschen.',
  tagName: 'Tag-Name',
  tagSearchAndFiltering: 'Tag-Suche & Filterung',
  tagSearchAndFilteringHelpText: 'Hinweis: Einige Such- und Filtereinstellungen sind auch in den „Tag Manager“-Tag-Editoren konfigurierbar, die hier zu finden sind: ',
  tagSubmitAffected: 'Bei jedem {type}-Inhalt wird zusätzlich zu den Änderungen automatisch das Tag {tag} entfernt.',
  tagValue: 'Tag-Wert | Tag-Werte',
  tagValueMissing: 'Sie müssen einen Tag-Wert eingeben',
  tagValueMultiple: 'Mehrere Einträge werden durch Semikolon getrennt',
  tagValueTooLong: 'Tag-Wert überschreitet die Beschränkung von 25 Zeichen | Tag-Werte überschreiten die Beschränkung von 25 Zeichen',
  tagsDeleteError: 'Ein oder mehrere Tags konnten nicht gelöscht werden',
  tagsDeleteSuccess: 'Tags erfolgreich gelöscht',
  tagsDisplayMore: 'Die ersten 100 Werte werden angezeigt. Verwenden Sie den Filter, um mehr anzuzeigen.',
  tagsManager: 'Tags-Manager',
  tagsSaveError: 'Ein oder mehrere Tags konnten nicht gespeichert werden',
  tagsSaveSuccess: 'Tags erfolgreich gespeichert',
  tagsUpdateError: 'Aktualisierung eines oder mehrerer Tags ist fehlgeschlagen',
  tagsUpdateSuccess: 'Tags erfolgreich aktualisiert',
  targetBrowseFlow: 'Ziel-Browser-Ablauf',
  taxon: 'Taxon',
  taxonomy: 'Taxonomie',
  template: 'Vorlage | Vorlagen',
  templateEmailRecipients: 'Vorlage E-Mail-Emfpänger',
  templateLayout: {
    addItem: 'Element hinzufügen',
    addRow: 'Zeile hinzufügen',
    deleteColumn: 'Spalte löschen',
    deleteRow: 'Zeile löschen',
    fullWidth: 'komplette Breite',
    oneColumn: 'eine Spalte',
    threeColumns: 'drei Spalten',
    twoColumns: 'zwei Spalten'
  },
  tenant: 'Mandant | Mandanten',
  tenantAdmin: 'Mandantenverwaltung',
  tenantAdminMessage: 'Steuert mandantenübergreifende Einstellungen',
  tenantCleanerJob: 'Mandantenerhalt',
  tenantConfiguration: 'Mandantenkonfiguration',
  tenantEmailRecipients: 'Empfänger der Mandanten-E-Mail',
  tenantEmailRecipientsOverrideMessage: 'Sie werden überschrieben, wenn E-Mail-Empfänger der Organisation angegeben werden',
  tenantIndexQueueJob: 'Mandantenindex-Warteschlange',
  tenantKey: 'Mandantenschlüssel',
  tenantKeyError: 'Mandantenschlüssel ist nicht eindeutig',
  tenantKeyMessage: 'Mandantenschlüssel muss eindeutig sein',
  tenantLabelDeleteMessage: 'Wenn diese Bezeichnung gelöscht wird, wird der Standard-Documoto-Name wieder verwendet.',
  tenantLabelsPageText: 'Bezeichnungen werden verwendet, um die Namen vieler Objekte, die Sie in der Bibliothek von Documoto und auf Verwaltungsbildschirmen sehen, individuell anzupassen.',
  tenantPrintSettingsDescription: 'Wählen Sie die mandantenübergreifende Druckeinstellung. Sie wird beim Drucken aller Bücher verwendet, sofern sie nicht auf Organisations- oder Medienebene überschrieben wird.',
  tenantReindexModulus: 'Mandanten-Neuindexzierungsmodul',
  tenantSettings: {
    collapseTOCLabel: 'Inhaltsverzeichnis auf Matching Page ausblenden',
    defaultLocaleLabel: 'Standard-Standort',
    defaultLocaleMessage: 'Standard-Standort des Mandanten',
    defaultSupplierLabel: 'Standard-Lieferant',
    defaultSupplierMessage: 'Standard-Lieferant des Mandanten',
    deleteMissingTranslationsOnPublishLabel: 'Fehlende Übersetzungen beim Veröffentlichen löschen?',
    deleteMissingTranslationsOnPublishMessage: 'Teilübersetzungen beim Veröffentlichen löschen aktivieren',
    enableChapterIndexingLabel: 'Aktiviert Indizierung von Medien-Kapiteln',
    enableChapterIndexingMessage: 'Kapitel indizieren',
    enableIndexingLabel: 'Index bei Veröffentlichung',
    enableIndexingMessage: 'Indizierung bei Veröffentlichung einschalten.',
    excludePartsFromAccessControlChecksLabel: 'Teile von den Zugriffskontrollregeln ausschließen',
    excludePartsFromAccessControlChecksMessage: 'Wenn diese Option aktiviert ist, sind Teile für alle Benutzer unabhängig von den Medienzugriffseinstellungen sichtbar.',
    exportPgAsHashLabel: 'Dateinamen der Seite als Hash-Schlüssel exportieren',
    exportPgAsHashMessage: 'Seiten-Hash-Schlüssel in exportierten Inhalten als Seitendateinamen verwenden',
    helpUrlLabel: 'Standard-Hilfe-URL',
    helpUrlMessage: 'URL eines alternativen Hilfe-Systems',
    hotPointLinkPageInBookOnlyLabel: 'Seiten-Hotpoint-Links nur in Buchung',
    hotPointLinkPageInBookOnlyMessage: 'Hotpoint-Links von Seiten nur in Buchung',
    lockPartTrOnPublishLabel: 'Teilübersetzungen beim Veröffentlichen sperren',
    lockPartTrOnPublishMessage: 'Verhindert, dass Teilübersetzungen während der Veröffentlichung geändert werden',
    mediaTimestampLabel: 'Medien-Zeitstempel auf der Zugangskontrolländerung aktualisieren',
    mediaTimestampMessage: 'Aktivieren Sie diese Option, wenn bei einer Änderung der Zugriffskontrollmedienkategorien der Zeitstempel des Mediums aktualisiert werden soll.',
    publisherDefaultUom: 'Standard-Maßeinheit des Herausgebers',
    publishingContactLabel: 'Kontakt-E-Mail wird veröffentlicht',
    publishingContactMessage: 'Die Standard-E-Mail-Adresse, an die E-Mails gesendet werden, wenn ein Problem mit dem Inhalt gemeldet wird.',
    replaceHotpointLabel: 'Hotpoint-Links beim Veröffentlichen immer ersetzen',
    replaceHotpointMessage: 'Nur für Docustudio-Veröffentlichungen.',
    ssoLoginSystemLabel: 'SSO Login-System',
    ssoLoginSystemMessage: 'Identitätssystem für SSO.',
    userPasswordExpirationLabel: 'Ablaufdaten des Benutzerpassworts',
    userPasswordExpirationMessage: 'Anzahl der Tage, nach denen Passwörter zurückgesetzt werden müssen; Feld leer lassen, damit das Passwort nie abläuft'
  },
  tenantSettingsSaved: 'Einstellungen des Mandanten Gespeichert',
  tenantSettingsSubtitle: 'Diese Einstellungen steuern mandantenweite Eigenschaften und Verhaltensweisen Seien Sie achtsam, wenn Sie Änderungen vornehmen. Für weitere Information setzen Sie sich mit dem Service von Documoto in Verbindung.',
  tenantSettingsTitle: 'Einstellungen des Mandanten',
  tenantSuppliers: 'Mandantenlieferanten',
  tenantType: 'Mandantentyp',
  tenantWebserviceUser: 'Mandanten-Webservice-Benutzer',
  text: 'Text',
  textArea: 'Textbereich',
  textColor: 'Textfarbe',
  textField: 'Textfeld',
  textFile: 'Textdatei (CSV, TXT)',
  textTool: 'Textwerkzeug',
  threeD: {
    addFile: '3D-Teiledatei hinzufügen',
    beforeSaveModal: {
      message: 'Möchten Sie diese Datei überall ersetzen, wo sie vorhanden ist, oder sie nur an diesen Teil anhängen? Wenn Sie sich für das Ersetzen der Datei entscheiden, geschieht Folgendes:',
      messageBulletOne: '{count} teil(e) wird/werden mit dieser neuen CAD-Datei aktualisiert',
      messageBulletOneForContent: '{count} {contentType} wird mit dieser neuen CAD-Datei aktualisiert.',
      messageBulletTwo: 'Die vorherige Version dieser Datei wird aus dem Documoto-Dateisystem entfernt.',
      tip: 'Tipp: Um zu verhindern, dass Dateien während des Anhängens überschrieben werden, können Sie den Dateinamen der Datei, die Sie anhängen möchten, vor dem Importieren ändern.',
      title: 'In Documoto ist bereits eine CAD-Datei mit diesem Dateinamen vorhanden.'
    },
    deleteTitle: 'Wollen Sie diese 3D-Ansicht wirklich löschen?',
    drawMode: {
      hiddenLines: 'Verborgene Linien',
      label: 'Zeichenmodus',
      shaded: 'Schattiert',
      wireframe: 'Drahtgitter',
      wireframeShaded: 'Drahtgitter Shaded'
    },
    explode: 'Explosion',
    failureCreatingBomAssociations: 'Fehler beim Erstellen von 3D-Modell-Stücklistenzuordnungen.',
    fileSizeModal: {
      message: 'Die maximal zulässige Dateigröße in Documoto beträgt 25 Megabyte. Die Datei, die Sie hochladen möchten, hat das Maximum überschritten und kann nicht geladen werden. Klicken Sie auf „OK“, um fortzufahren.',
      title: 'Maximal zulässige Dateigröße überschritten'
    },
    fileSizeModalWarning: {
      message: 'Die maximal zulässige Dateigröße in Documoto beträgt {size} Megabyte. Eine der Dateien, die Sie hochladen möchten, überschreitet die maximale Größe und kann nicht geladen werden. Klicken Sie auf „OK“, um fortzufahren.',
      title: 'Maximal zulässige Dateigröße überschritten'
    },
    freeTierCurrentCount: 'Sie haben {count} von 15 aktiven 3D-Modellen im kostenlosen Tarif. Sobald Sie das Limit erreicht haben, können Sie keine neuen Seiten mit 3D-Modellen mehr veröffentlichen. Wenden Sie sich an Ihren Customer Success Manager, um Ihr Abonnement zu aktualisieren.',
    freeTierExceededError: 'Die Veröffentlichung dieser Seite mit einem 3D-Modell ist nicht gestattet.',
    freeTierExceededOption1: 'Wenden Sie sich an Ihren Customer Success Manager, um Ihr Abonnement zu aktualisieren.',
    freeTierExceededOption2: 'Um die Seite zu veröffentlichen, muss das 3D-Modell aus dem Seitenentwurf entfernt werden.',
    freeTierExceededTitle: 'Sie haben die Grenze von 15 aktiven 3D-Modellen überschritten.',
    illustrationLabel: '2D-Ansicht',
    invalidFile: 'Ungültige Datei zum Hochladen übermittelt',
    mapModelToBom: 'Modell der Stückliste zuordnen',
    modelLabel: '3D-Modell',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Es konnten keine Stücklistenteile gefunden werden, die den Teilenummern des 3D-Modells entsprechen',
    noPartsMatchRegEx: 'Keine Stücklistenteile stimmen mit dem regulären Ausdruck überein',
    orientation: 'Ausrichtung',
    orientationAndProjection: {
      back: 'Zurück',
      bottom: 'Unten',
      front: 'Vorn',
      isometric: 'Isometrisch',
      left: 'Links',
      orthographic: 'Orthographisch',
      perspective: 'Perspektive',
      projection: 'Projektion',
      right: 'Rechts',
      top: 'Oben'
    },
    partNumberProperty: 'Teilenummer-Eigenschaft',
    partNumberRegex: 'Teilenummer-Regex',
    partNumbersInModel: 'Teilenummern im Modell',
    resetCamera: 'Kamera zurücksetzen',
    setAsDefaultView: 'Als Standardansicht festlegen',
    setAsDefaultViewTooltip: 'Diese Ausrichtung und Zoomstufe als Standardstartansicht festlegen.',
    slice: {
      label: 'Schnitt',
      planeX: 'Schnittebene X',
      planeY: 'Schnittebene Y',
      planeZ: 'Schnittebene Z',
      reset: 'Schnittebene zurücksetzen',
      section: 'Schnittebenen-Abschnitt umschalten',
      visibility: 'Schnittebenen-Sichtbarkeit umschalten'
    },
    successfullyCreatedBomAssociations: '{count} 3D-Modell-Stücklistenzuordnungen erfolgreich erstellt',
    successfullySavedDefaultView: 'Standardansicht erfolgreich gespeichert',
    supportedFilesMessage: 'Documoto unterstützt viele CAD-Dateiformate. Prüfen Sie das Support Center, wenn Sie nicht sicher sind, ob Ihr CAD-Dateiformat unterstützt wird.',
    threeD: '3D',
    toolsLabel: '3D Tools',
    topAssemblyFilename: 'Dateiname der obersten Baugruppe',
    topAssemblyFilenameInvalid: 'Die Baugruppendatei der obersten Ebene ist nicht in der Dateiliste enthalten',
    topAssemblyFilenameRequired: 'Dateiname der obersten Baugruppe erforderlich',
    viewerControls: 'Viewer-Steuerelemente',
    viewerSettings: '3D-Viewer-Einstellungen',
    viewerTitle: '3D Viewer'
  },
  thu: 'Do.',
  thumbnail: 'Miniaturansicht',
  thumbnailDeleted: 'Miniaturansicht Erfolgreich Gelöscht',
  thumbnailDeletedError: 'Miniaturansicht konnte Nicht Gelöscht werden',
  thumbnailReapplyWarning: 'Das System kann eine Miniaturansicht aufgrund des Medieninhalts wiederverwenden. Dies kann einige Minuten dauern.',
  thumbnailResizeTooltip: 'Passt die Größe von Thumbnails auf max. 500x500 Pixel an, falls markiert',
  thumbnailUpdated: 'Miniaturansicht Erfolgreich Aktualisiert',
  thumbnailUpdatedError: 'Miniaturansicht konnte Nicht Aktualisiert werden',
  title: 'Titel',
  to: 'An',
  toDate: 'Bis Heute',
  toGetStarted: 'um zu beginnen.',
  toastNotifications: 'Popup-Benachrichtigungen',
  toc: 'Inhaltsverzeichnis',
  tocClipBoardSuccessTitle: 'In die Zwischenablage kopiert',
  tocClipBoardWarningText: 'WARNHINWEIS: Nicht gespeicherte Änderungen können nicht in Ihre Zwischenablage kopiert werden',
  tocClipBoardWarningTitle: 'In die Zwischenablage kopiert',
  tocDisplayingFirstValues: 'Die ersten 100 Werte werden angezeigt. Verwenden Sie den Filter, um mehr anzuzeigen.',
  tocDuplicateWarningText: 'Duplikat einer Seite wurde in einem Kapitel entdeckt. Das Duplikat wurde entfernt.',
  tocEmptyMessage: 'Sie scheinen noch kein Inhaltsverzeichnis erstellt zu haben.',
  tocMissingChapterName: 'Kapitelname fehlt',
  tocModalTableCaption: 'Tag Editor Modal',
  tocNothingSelected: 'Es wurde nichts Ausgewählt',
  tocOpenEditor: 'Editor öffnen',
  tocSaveRequired: 'Sie müssen vor dem Bearbeiten von Kapiteldetails speichern',
  tocState: 'Anfangszustand des Inhaltsverzeichnisses',
  tocThumbnailDeleteFailTitle: 'Miniaturansicht konnte Nicht Gelöscht werden',
  tocThumbnailDeleteSuccessTitle: 'Miniaturansicht Erfolgreich Gelöscht',
  tocThumbnailUploadFailTitle: 'Miniaturansicht konnte Nicht Hochgeladen werden',
  tocThumbnailUploadSuccessTitle: 'Miniaturansicht Erfolgreich Hochgeladen',
  tocTranslationMessage: 'Der Name und die optionale Beschreibung dieses Kapitels',
  tocUntitledPage: 'Unbenannte Seite',
  togglePage: 'Seite Wechseln',
  tooManySelections: 'Liste überschreitet Auswahllimit von {limit}',
  top: 'Oben',
  total: 'Gesamt',
  totalItems: 'Elemente insgesamt',
  translation: 'Übersetzung | Übersetzungen',
  translationHelpTextItem: 'Der Name und die optionale Beschreibung von {item}',
  'true': 'Richtig',
  tryAgain: 'Bitte versuchen Sie es noch einmal.',
  trySearchingToc: 'Versuchen Sie, nach jedem Wort zu suchen, das Sie sehen oder an das Sie sich erinnern – die Liste grenzt sich sofort ein. Die Ansicht ändert sich erst, wenn Sie auf ein Ergebnis klicken.',
  tryThis: 'Ausprobieren',
  tue: 'Di.',
  turkishDescription: 'Türkische Beschreibung',
  turkishName: 'Türkischer Name',
  twoSided: 'Zweiseitig',
  type: 'Typ | Typen',
  typeAtLeastTwoChars: 'Geben Sie mindestens 2 Zeichen ein, um eine Liste mit Übereinstimmungen anzuzeigen.',
  typeSearchCriteriaAlreadySet: 'Löschen Sie die ausgewählten Suchkriterien unter „Typ“, um die Änderungen zu übernehmen.',
  typeToConfirm: '{value} zum Bestätigen eingeben',
  typography: 'Typografie',
  ukraineDescription: 'Ukrainische Beschreibung',
  ukraineName: 'Ukrainischer Name',
  unableToRetrieveResults: 'Für Ihre Anfrage/Suche konnten keine Ergebnisse gefunden werden',
  unauthorized: 'Nicht autorisiert',
  unknownError: 'Unbekannter Fehler, bitte kontaktieren Sie Documoto Support unter support{\'@\'}documoto.com',
  unknownInput: 'Unbekannter Eingabetyp:',
  unknownPart: 'Unbekanntes Teil',
  unknownType: 'Unbekannter Typ',
  unsavedAPIKeyWarning: 'Ihr API-Schlüssel geht verloren, wenn Sie nicht Zurückgehen',
  unsavedChanges: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie fortsetzen?',
  unsavedChangesWarning: 'Ihre Änderungen gehen verloren, wenn Sie sie nicht speichern.',
  unsavedWidgetKeyWarning: 'Ihr Widget-Schlüssel geht verloren, wenn Sie nicht zurückkehren.',
  unsupportedBrowserMessage: 'Wir haben diese Anwendung mithilfe der neuesten Technologie entwickelt. Dadurch wird die Anwendung schneller und benutzerfreundlicher. Leider unterstützt Ihr Browser diese Technologien nicht.',
  untitledOrg: 'Unbenannte Organisation',
  unverified: 'Nicht verifiziert',
  uom: 'Maßeinheit',
  update: 'Aktualisieren',
  updateFailed: 'Aktualisierung fehlgeschlagen',
  updateIndex: 'Verzeichnis aktualisieren',
  updatePassword: 'Passwort aktualisieren',
  updatePasswordMessage: 'Passwort erfolgreich aktualisiert',
  updatePasswordPending: 'Speichern der Passwortänderung ist ausständig.',
  updated: 'Aktualisiert',
  upgradeBrowser: 'Bitte führen Sie eine Aktualisierung Ihres Browsers durch.',
  upload: 'Hochladen',
  uploadComplete: 'Hochladen Abgeschlossen',
  uploadFileSizeLimitExceeded: 'Die Datei überschreitet das Dateigrößenlimit für die Anzeige in der App.',
  uploadInProgress: 'Hochladen wird Durchgeführt',
  uponSavingDisabledTenant: 'Wenn diese Seite mit aktivierter Einstellung gespeichert wird, geschieht Folgendes:',
  uponSavingThisLicense: 'Wenn Sie diese Seite mit dieser Einstellung speichern, MÜSSEN Sie FOLGENDES TUN:',
  upperBound: 'Obere Grenze',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Standard-Warenkorb-Spalten verwenden',
  useDefaultPartsListColumns: 'Standardspalten für Teileliste verwenden',
  useSequentialPageNumbering: 'Fortlaufende Seitennummerierung verwenden',
  useSniForSsoMetadataRetrieval: 'SNI für SSO-Metadatenabruf verwenden',
  user: 'Benutzer',
  userAddress: 'Benutzeradresse | Benutzeradressen',
  userCount: 'Benutzeranzahl',
  userEditable: 'Vom Benutzer Bearbeitbar',
  userExpirationDate: 'Benutzer Ablaufdatum',
  userExpirationDateInvalid: 'Benutzer Ablaufdatum ist ein Pflichtfeld',
  userGroup: 'Benutzergruppe | Benutzergruppen',
  userGroupEmpty: 'Benutzergruppen darf nicht leer sein',
  userGroupType: 'Benutzergruppen-Typ',
  userGroupUniqueMessage: 'Der Name muss sich von allen anderen Benutzergruppennamen für diesen Mandanten unterscheiden',
  userGroupUsers: 'Benutzergruppe-Benutzer',
  userSettings: 'Benutzereinstellungen',
  userVerificationEmailBody: 'E-Mail-Hauptteil der Benutzerbestätigung',
  userVerificationEmailFieldsValidation: 'Die Felder für die E-Mail-Adresse zur Benutzerbestätigung müssen entweder beide nicht leer oder beide leer sein',
  userVerificationEmailSubject: 'E-Mail-Betreff der Benutzerbestätigung',
  username: 'Benutzername',
  usernameEmpty: 'Benutzername darf nicht leer sein',
  users: 'Benutzer',
  usersWillReceiveAnUnauthorizedError: 'Beim Versuch, sich beim Mandanten anzumelden, wird den Benutzern die Fehlermeldung „Nicht autorisiert“ angezeigt.',
  validate: 'Validieren',
  validateTenantDirectories: {
    buttonLabel: 'Inhaltsverzeichnisse validieren',
    error: 'Inhaltsverzeichnisse konnten nicht validiert werden',
    success: 'Validierte Mandantenverzeichnisse'
  },
  validationMessage: 'Validierungsnachricht | Validierungsnachrichten',
  value: 'Wert',
  valueGteError: 'Wert muss weniger oder gleich {max} betragen',
  valueLteError: 'Wert muss größer oder gleich {min} betragen',
  variantSKU: 'Bestandseinheit-Variante',
  vendorName: 'Lieferantenname',
  verificationEmailRequested: 'Beim Speichern wird eine Bestätigungs-E-Mail gesendet.',
  verificationEmailSent: 'Bestätigungs-E-Mail gesendet. Passwort nicht festgelegt.',
  verified: 'Verifiziert',
  verifyPassword: 'Passwort prüfen',
  verifying: 'Wird verifiziert',
  version: 'Version',
  vertical: 'Vertikal',
  video: 'Video | Videos',
  view: 'Anzeigen',
  viewAll: 'Alle anzeigen',
  viewAllPagesAndBooks: 'Anzeigen: Alle Seiten und Bücher',
  viewAllResults: 'Alle Ergebnisse anzeigen',
  viewBooks: 'Anzeigen: Bücher',
  viewModeList: 'Listenansicht',
  viewModeTable: 'Tabellenansicht',
  viewMore: 'Mehr anzeigen',
  viewPages: 'Anzeigen: Seiten',
  viewWhereUsed: 'Verwendungsnachweis anzeigen',
  views: 'Ansichten',
  visibility: 'Sichtbarkeit',
  visibilityDescription: 'Wer kann diese {entity} sehen',
  visible: 'Sichtbar',
  waitForUpload: 'Bitte warten Sie, bis das Hochladen abgeschlossen ist.',
  watermark: 'Wasserzeichen',
  watermarkFont: 'Schriftart Wasserzeichen',
  watermarkOpacityPercentage: '% Opazität Wasserzeichen',
  watermarkOrientation: 'Ausrichtung Wasserzeichen',
  watermarkSaveFailed: 'Wasserzeichen konnte nicht gespeichert werden.',
  watermarkSaved: 'Wasserzeichen gespeichert',
  watermarkSelectionRequired: 'Nutzername oder Textauswahl erforderlich.',
  watermarkText: 'Wasserzeichen-Text',
  wed: 'Mi.',
  whereUsed: 'Verwendungsnachweis',
  whereUsedCountInSearchBar: 'Verwendungsnachweis-Anzahl in der Suchleiste',
  whoCanViewComment: 'Wer kann diesen Kommentar sehen?',
  wholesale: 'Großhandel',
  wholesalePrice: 'Großhandelspreis',
  wholesaleTotal: 'Großhandel Gesamt',
  widget: 'Widget',
  widgetAuthHeader: 'Widget-Autorisierungswert',
  widgetErrorConfig: 'Widget konnte aufgrund einer fehlerhaften Widget-Konfiguration nicht initialisiert werden',
  widgetErrorInit: 'Documoto-Widget konnte nicht initialisiert werden',
  widgetErrorLocation: 'Der angegebene Inhalt konnte innerhalb des Widgets nicht gefunden werden',
  widgetErrorMultipleLocations: 'Für den angegebenen Inhalt wurden mehrere Verwendungsstellen gefunden',
  widgetKey: 'Widget-Schlüssel | Widget-Schlüssel',
  widgetKeyAdmin: 'Widget-Schlüssel-Admin',
  widgetKeyCopied: 'Widget-Autorisierungswert in Zwischenablage kopiert',
  widgetKeyDeleteMsg: 'Wenn der Widget-Schlüssel gelöscht wird, kann er nicht mehr verwendet werden.',
  widgetKeyDeleted: 'Widget-Schlüssel gelöscht',
  widgetKeyDeletedError: 'Fehler beim Löschen des Widget-Schlüssels',
  widgetKeyManager: 'Widget-Schlüssel-Manager',
  widgetKeyNameEmpty: 'Der Name muss einzigartig sein und ist ein Pflichtfeld. Dieser Wert wird auch zu Berichts- und Protokollierungszwecken als Benutzername für jede Widget-Aktivität verwendet',
  widgetKeyRegenError: 'Fehler beim Generieren eines Widget-Schlüssels',
  widgetKeyRegenMsg: 'Die Neugenerierung dieses Widget-Schlüssels kann bestehende Integrationen deaktivieren.',
  widgetKeyRegenTitle: 'Diesen Widget-Schlüssel wirklich neu generieren?',
  widgetKeySaved: 'Widget-Schlüssel gespeichert',
  widgetPermissions: 'Widget-Benutzer können nur lesen und der Zugriff auf Funktionen wird über die Konfiguration auf Widget-Ebene verwaltet. Standardberechtigungen für Benutzergruppen gelten nicht für Widget-Benutzer, im Gegensatz zu den Zugriffsberechtigungen für Medienkategorien. Bitte fahren Sie mit der Zuweisung von Zugriffskontrollen für Medienkategorien fort.',
  widgetRefreshErrorMsg: 'Bitte aktualisieren Sie Ihre Seite, um den gewünschten Inhalt anzuzeigen',
  widgetUserGroup: 'Widget-Benutzergruppe',
  widgetUserGroupDeleteMsg: 'Widget-Gruppe mit Benutzern kann nicht gelöscht werden',
  willBeAffected: 'wird beeinflusst.',
  willBeDeleted: '{content} wird gelöscht.',
  willBeInsertedIntoItem: '{name} wird in {item} eingefügt',
  willBeUpdated: 'wird aktualisiert.',
  year: 'Jahr',
  yourEmailAddress: 'Ihre E-Mail-Adresse',
  zipCode: 'Postleitzahl',
  zoomHotpointToCanvas: 'Hotpoint auf Leinwandgröße zoomen',
  zoomIn: 'Heranzoomen',
  zoomOut: 'Herauszoomen'
};
/* eslint-enable max-len */
